
export const latestArrivalList=[{
    id:"poster1",
    author:"Abraham, K.A.",
    book:"Rethinking Hope: Christian Eschatology Rediscovered.",
    year:"2021",
    publisher:"Delhi: Christian World Imprints",
    poster:require('./assets/poster/poster1.jpeg'),
    authorPic:require('./assets/images/defaultAvatar.jpg')

  },{
    id:"poster2",
    author:"Abraham, Molly",
    book:"A Saga of Tolerance and a Legacy for Posterity: Catholic Visionaries and Women’s Empowerment in North India.",
    year:"2021",
    publisher:"Delhi: ISPCK",
    poster:require('./assets/poster/poster2.jpeg'),
       authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster3",
    author:"Aggarwal, Suman Khanna",
    book:"The Science of Peace.",
    year:"2019",
    publisher:"New Delhi: Shanti Sahyog Center for Peace and Conflict Resolution",
    poster:require('./assets/poster/poster3.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster4",
    author:"Amaladass, Vinothraj",
    book:"Breaking Pyramid: A Dalit-Self’s New Humanity",
    year:"2020",
    publisher:"Delhi: ISPCK",
    poster:require('./assets/poster/poster4.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster5",
    author:"Ansari, Tahir Hussain",
    book:"Mughal Administration and the Zamindars of Bihar",
    year:"2019",
    publisher:"New Delhi: Manohar",
    poster:require('./assets/poster/poster5.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster6",
    author:"Baptist, John and Team (eds.)",
    book:"St Joseph: Shadow of the Heavenly Father.",
    year:"2021",
    publisher:"Mumbai: Pauline",
    poster:require('./assets/poster/poster6.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster7",
    author:"Chalcraft, David J. and Zhodi Angami (eds.).",
    book:"A Biblical Masala: Encountering Diversity in Indian Biblical Studies.",
    year:"2021",
    publisher:"Delhi: Christian World Imprints",
    poster:require('./assets/poster/poster7.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')

  },{
    id:"poster8",
    author:"Chhotebhai",
    book:"The Jerusalem Code.",
    year:"2020",
    publisher:"Kanpur: Indian Catholic Forum",
    poster:require('./assets/poster/poster8.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster9",
    author:"Christopher, Sam",
    book:"Jesus the King: A Paradigm for Liberation (Christology of Luke’s Gospel)",
    year:"2019",
    publisher:"Delhi: ISPCK",
    poster:require('./assets/poster/poster9.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster10",
    author:"D’Souza, Wilson",
    book:"A Choice between Light and Darkness: An Exegetical, Theological and Contextual Reading of John 8:12.",
    year:"2021",
    publisher:"Delhi: Media House",
    poster:require('./assets/poster/poster10.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster11",
    author:"Daniel, Monodeep and Samuel John Shekhar",
    book:"Flourishing Communities: Insights from Ambedkar and Bible",
    year:"2021",
    publisher:"Delhi: ISPCK",
    poster:require('./assets/poster/poster11.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster12",
    author:"Doss, Jesu Pudumai, Sahaydas Fernando and Maria Charles Antonysamy (eds.)",
    book:"Pathways to Fraternity: Educating the Young in the Lights of ‘Fratelli Tutti’",
    year:"2021",
    publisher:"New Delhi: All India Don Bosco Education Society",
    poster:require('./assets/poster/poster12.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster13",
    author:"Edwin, Joseph Victor",
    book:"A New Spirit in Christian-Muslim Relations in India: Three Jesuit Pioneers",
    year:"2021",
    publisher:"Delhi: ISPCK",
    poster:require('./assets/poster/poster13.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster14",
    author:"Ferrao, Victor",
    book:"Being Human in a World of Artificial Intelligence: Quest for Fusions of Sangam",
    year:"2020",
    publisher:"Delhi: Christian World Imprints",
    poster:require('./assets/poster/poster14.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster15",
    author:"Haidar, Mansura",
    book:"Mirza Muhammad Haidar Dughlat Kurkan",
    year:"2019",
    publisher:"New Delhi: Manohar Publishers",
    poster:require('./assets/poster/poster15.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster16",
    author:"Inamdar, Areef",
    book:"Political Ideas of Dr. Zakir Husain",
    year:"2019",
    publisher:"New Delhi, Madhav Books",
    poster:require('./assets/poster/poster16.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster17",
    author:"Jayard, S. Stephen",
    book:"Mary for Modern Times: Reflections on Meaning and Message of Marian Devotion.",
    year:"2019",
    publisher:"Delhi: Christian World Imprints",
    poster:require('./assets/poster/poster17.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster18",
    author:"Jones, J. Stanly",
    book:"The Jesus Movement and Its Resistance to Oppressive Institutions: A Study of Healing Narratives in Mark’s Gospel.",
    year:"2020",
    publisher:"Delhi: ISPCK",
    poster:require('./assets/poster/poster18.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster19",
    author:"Jose, V.M.",
    book:"Towards a Local Tribal Church: An Anthropological and Missiological Exploration of the Jesuits among the Santals.",
    year:"2021",
    publisher:"Pune: Jnana-Deepa Vidyapeeth and Delhi: Christian World Imprints",
    poster:require('./assets/poster/poster19.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster20",
    author:"Joy, C.I. David and Ebenezer Shinekumar (eds.).",
    book:"Subaltern Historiography: A Reader.",
    year:"2020",
    publisher:"Delhi: ISPCK, Hydrabad: Henry Martyn Institute and Kerala: Kerala United Theological Seminary",
    poster:require('./assets/poster/poster20.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster21",
    author:"Kalambukattu, Naiju Jose",
    book:"Theologizing in Context: A Hermeneutic of Living Dialogue between the Word and the World.",
    year:"2019",
    publisher:"Bengaluru: Dharmaram Publications",
    poster:require('./assets/poster/poster21.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster22",
    author:"Karimundackal, Thomas (ed.).",
    book:"Faith – Freedom – Commitment: Biblical and Theological Reflections for Today Inspired by George M. Soares-Prabhu, S.J.",
    year:"2021",
    publisher:"Delhi: ISPCK",
    poster:require('./assets/poster/poster22.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster23",
    author:"Karunanidhi, Yesu",
    book:"Divine – Human Symphony: A Comparative Reading of Ecclesiastes and Pattinattar",
    year:"2020",
    publisher:"Delhi: Christian World Imprints",
    poster:require('./assets/poster/poster23.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster24",
    author:"Kumaradoss, Y. Vincent",
    book:"From the Pen of Scholar-Missionary Robert Caldwell (1814-1891): Selected Letters and Other Writings",
    year:"2021",
    publisher:"Delhi: ISPCK",
    poster:require('./assets/poster/poster24.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster25",
    author:"Lalenkawla",
    book:"Socio-Political Significance of Covenant Motif in the Old Testament: Reading the Theology of Prophet Jeremiah from a Tribal Perspective.",
    year:"2020",
    publisher:"Delhi: Christian World Imprints",
    poster:require('./assets/poster/poster25.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster26",
    author:"Lalrinliana, R",
    book:"Church and State Relations in Pauline Epistles: Its Implications for Religion and Politics in Mizoram.",
    year:"2019",
    publisher:"Delhi: Christian World Imprints",
    poster:require('./assets/poster/poster26.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster27",
    author:"Lalrinthanga, H",
    book:"Gospel and Culture: An Interaction between Christianity and Mizo Culture",
    year:"2020",
    publisher:"Delhi: Christian World Imprints",
    poster:require('./assets/poster/poster27.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster28",
    author:"Louis, Prakash",
    book:"Fr. Stan Swamy: A Maoist or a Martyr? ",
    year:"2021",
    publisher:"Delhi: Media House and Sahithya Pravarthaka Co-operative Society Ltd.",
    poster:require('./assets/poster/poster28.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster29",
    author:"Lourduraj, William M.",
    book:"C. J. Beschi Sj (Veeramamunivar): A Missionary, Tamil Scholar, and Theologian",
    year:"2021",
    publisher:"Delhi: ISPCK",
    poster:require('./assets/poster/poster29.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster30",
    author:"Lunggleng, Lengmi",
    book:"Interfaith Marriage: Pastoral Concerns",
    year:"2019",
    publisher:"Delhi: ISPCK",
    poster:require('./assets/poster/poster30.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster31",
    author:"Mangai, Poulose and Joseph Victor Edwin (eds.)",
    book:"Seeing the Other in the Mirror of Christ: 800th Anniversary of the Saint-Sultan Encounter",
    year:"2021",
    publisher:"Delhi: Media House",
    poster:require('./assets/poster/poster31.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster32",
    author:"Marchetto, Agostino and Angelo Federico Arcelli.",
    book:"Communion: Reflections for an Intra-Ecclesial Dialogue.",
    year:"2021",
    publisher:"Soveria Mannelli: CLE",
    poster:require('./assets/poster/poster32.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster33",
    author:"",
    book:"Riflessioni: Per un dialogo intraecclesiale.",
    year:"2021",
    publisher:"Soveria Mannelli: Rubbettino",
    poster:require('./assets/poster/poster33.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster34",
    author:"Mathew, Sinimol",
    book:"From Glory to Holy: An Inner Life Journey through the Renewed Temple of Prophet Ezekiel and Spiritual Doctrines of St. John of the Cross.",
    year:"2020",
    publisher:"Delhi: Christian World Imprints",
    poster:require('./assets/poster/poster34.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster35",
    author:"Mathias, R",
    book:"Word of God: To Preach and to Practice Homilies for Sundays and Solemnities.",
    year:"2019",
    publisher:"Bengaluru: SFS Publications",
    poster:require('./assets/poster/poster36.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster36",
    author:"Mendonca, Valerian (ed.)",
    book:"Ancient, Medieval and Modern Philosophy: A Historical Introduction (500 BC-1800 AD)",
    year:"2021",
    publisher:"Pune: Jnana-Deepa Vidyapeeth and Delhi: Christian World Imprints",
    poster:require('./assets/poster/poster36.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster37",
    author:"",
    book:"Contemporary Philosophy: A Historical Introduction (1800-2020 AD).",
    year:"2021",
    publisher:"Pune: Jnana-Deepa Vidyapeeth and Delhi: Christian World Imprints",
    poster:require('./assets/poster/poster37.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster38",
    author:"Miller, Robert D",
    book:"The Oral World of the Old Testament: A Historical Preview.",
    year:"2021",
    publisher:"Delhi: Christian World Imprints",
    poster:require('./assets/poster/poster38.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster39",
    author:"Oliparambil, Joseph",
    book:"Human Responsibility in Salvation: Understanding Christian Soteriology in Hindu Context.",
    year:"2021",
    publisher:"Delhi: Christian World Imprints",
    poster:require('./assets/poster/poster39.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster40",
    author:"Oosterhuis, Melle H",
    book:"Blessed are the Pure in Heart: Bible Studies in the Old and the New Testaments.",
    year:"2021",
    publisher:"Delhi: Christian World Imprints",
    poster:require('./assets/poster/poster40.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster41",
    author:"Pakhuongte, Fidelia Lallawmzuali",
    book:"An Evaluation of the Old Testament Women against the Ideal Woman in Proverbs.",
    year:"2021",
    publisher:"Delhi: Christian World Imprints",
    poster:require('./assets/poster/poster41.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster42",
    author:"Prasuna, Nelavala Gnana",
    book:"Engendering the Divine Image: Conversation with Dalit Women’s Experience.",
    year:"2020",
    publisher:"Delhi: Christian World Imprints",
    poster:require('./assets/poster/poster42.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster43",
    author:"Punnackad, Mathew Koshy",
    book:"The Green God of the Bible.",
    year:"2020",
    publisher:"Delhi: ISPCK and Chennai: Church of South India",
    poster:require('./assets/poster/poster43.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster44",
    author:"Purakary, Clare",
    book:"Oraon Christian’s Way of Life: Interaction of Faith and Culture.",
    year:"2019",
    publisher:"Delhi: Christian World Imprints",
    poster:require('./assets/poster/poster44.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster45",
    author:"Raja, Joshua, et al",
    book:"From Cultures of Conflict to Culture of Peace: Witnessing Christ in Multi-Faith Contexts.",
    year:"2020",
    publisher:"Delhi: ISPCK",
    poster:require('./assets/poster/poster45.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster46",
    author:"Ralte, Rodinmawia",
    book:"Inter-Religious Relations in India: Challenges and Prospects.",
    year:"2021",
    publisher:"Delhi: Christian World Imprints",
    poster:require('./assets/poster/poster46.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster47",
    author:"Ray, Aniruddha",
    book:"The Sultanate of Delhi (1206-1526): Polity, Economy, Society and Culture.",
    year:"2019",
    publisher:"New Delhi",
    poster:require('./assets/poster/poster47.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster48",
    author:"Regulas, Bouvert",
    book:"Holy Communion",
    year:"2021",
    publisher:"Delhi: ISPCK",
    poster:require('./assets/poster/poster48.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster49",
    author:"",
    book:"Revelation of Jesus Christ.",
    year:"2019",
    publisher:"Delhi: ISPCK",
    poster:require('./assets/poster/poster49.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster50",
    author:"Robertson, Selvam",
    book:"Understanding the Role of Religion in Building up Sustainable Existence: Issues and Challenges.",
    year:"2021",
    publisher:"Delhi: Christian World Imprints",
    poster:require('./assets/poster/poster50.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster51",
    author:"Rupwate, Daniel",
    book:"Covenantal Relationship Between the Lord God and His People: Nine Textual Sermons on Covenant Sunday or New Year Sunday with ‘The Covenant Theology of the Reverend John Wesley’ and an Enlarged Historical Preface to the “Covenant with God Service”",
    year:"2019",
    publisher:"Delhi: ISPCK",
    poster:require('./assets/poster/poster51.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster52",
    author:"Sadananda, Daniel Rathnakara and Paul J. Solomon (eds.)",
    book:"Rethinking Ecclesia: Being and Becoming Christ Communities: Towards a Borderless Church. Biblical and Theological Perspectives. Vol. I",
    year:"2021",
    publisher:"Delhi: ISPCK and Chennai: The Church of South India",
    poster:require('./assets/poster/poster52.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster53",
    author:"",
    book:"Rethinking Ecclesia: Being and Becoming Christ Communities: Towards a Borderless Church. Liturgical, Missiological and Prophetic Diaconal Perspectives. Vol. II.",
    year:"2021",
    publisher:"Delhi: ISPCK and Chennai: The Church of South India",
    poster:require('./assets/poster/poster53.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster54",
    author:"",
    book:"Rethinking Ecclesia: Being and Becoming Christ Communities: Towards a Borderless Church. National and Global Ecumenical Perspectives. Vol. IV.",
    year:"2021",
    publisher:"Delhi: ISPCK and Chennai: The Church of South India",
    poster:require('./assets/poster/poster54.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster55",
    author:"Selvanayagam, Israel",
    book:"Interreligious Life Issues: Relationship, Education, Prayer, Marriage, Funeral and Engagement.",
    year:"2019",
    publisher:"Delhi: Christian World Imprints",
    poster:require('./assets/poster/poster55.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster56",
    author:"Singsit, Lalboi",
    book:"Christian Theology and Tribal Culture: In Dialogue with C.S. Song",
    year:"2019",
    publisher:"Delhi: Christian World Imprints",
    poster:require('./assets/poster/poster56.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster57",
    author:"Smmi, Devapriya",
    book:"Woman You Are Set Free",
    year:"2020",
    publisher:"Delhi: ISPCK",
    poster:require('./assets/poster/poster57.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster58",
    author:"Somi, Jajo",
    book:"Retributive Justice and Ethics of Love Relating to Rape Victim",
    year:"2019",
    publisher:"Delhi: Christian World Imprints",
    poster:require('./assets/poster/poster58.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster59",
    author:"Stanislaus, Lazar T. and Christian Tauchner (eds.)",
    book:"Becoming Intercultural: Perspectives on Mission",
    year:"2021",
    publisher:"Delhi: ISPCK",
    poster:require('./assets/poster/poster59.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster60",
    author:"Syiemlieh, David R. and Ivan D’Silva (eds.)",
    book:"Legacy of Catholic Church in Tripura (1996-2021): Pathways Ahead",
    year:"2021",
    publisher:"Delhi: ISPCK",
    poster:require('./assets/poster/poster60.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster61",
    author:"Thainis, A",
    book:"John Peter – The Servant of God: A Complete Documentation of Original Sources",
    year:"2021",
    publisher:"Trichy: Franciscan Oli Publication",
    poster:require('./assets/logo/VJ-College-logo.png'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster62",
    author:"Thomas, Arun",
    book:"Healing Discourse in the Gospel of Mark: A Socio-Political Reading",
    year:"2020",
    publisher:"Delhi: Christian World Imprints",
    poster:require('./assets/poster/poster62.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster63",
    author:"Thomas, M.C",
    book:"Othering and Embodiment: Intersectional Imaginations in the Old Testament Narratives",
    year:"2021",
    publisher:"Delhi: Christian World Imprints",
    poster:require('./assets/poster/poster63.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster64",
    author:"Vallooran, Augustine",
    book:"In search of the Absolute: A Critical Study of the Advaitic Philosophy of the Equality of Religions",
    year:"2021",
    publisher:"Bengaluru: ATC Publishers",
    poster:require('./assets/poster/poster64.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster65",
    author:"Vashum, Yangkahao",
    book:"Faith Seeking Transformation: Rethinking Faith, Theology and Mission in North India",
    year:"2020",
    publisher:"Delhi: Christian World Imprints",
    poster:require('./assets/poster/poster65.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster66",
    author:"Vattamattam, Sebasitna (ed.)",
    book:"Collected Works of Sebastian Kappen: Jesus and Freedom and Related Essays. Vol. I.",
    year:"2020",
    publisher:"Delhi: ISPCK",
    poster:require('./assets/poster/poster66.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster67",
    author:"",
    book:"Collected Works of Sebastian Kappen: Jesus and Cultural Revolution and Related Essays. Vol. III.",
    year:"2020",
    publisher:" Delhi: ISPCK",
    poster:require('./assets/poster/poster67.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster68",
    author:"",
    book:"Collected Works of Sebastian Kappen: Liberation Theology and Marxism and Related Essays. Vol. IV",
    year:"2021",
    publisher:"Delhi: ISPCK",
    poster:require('./assets/poster/poster68.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster69",
    author:"",
    book:"Collected Works Sebastian Kappen: Hindutva and Indian Religious Traditions. Vol. V.",
    year:"2021",
    publisher:"Delhi: ISPCK",
    poster:require('./assets/poster/poster69.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster70",
    author:"Wilfred, Felix",
    book:"Theology for an Inclusive World",
    year:"2019",
    publisher:"Delhi: ISPCK",
    poster:require('./assets/poster/poster70.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster71",
    author:"Xavier, Francis G",
    book:"100 Great Inspiring Stories.",
    year:"2019",
    publisher:"Mumbai: Jaico Publishing House",
    poster:require('./assets/poster/poster71.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  },{
    id:"poster72",
    author:"Xavier, S. Basil",
    book:"Philosophies of Margins: Theoretical Foundations and Illustrative Models of Application.",
    year:"2020",
    publisher:"Madurai: SHANLAX Publications",
    poster:require('./assets/poster/poster72.jpeg'),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  }];

  export const coursesOffered=[{
    "courseID":"VJD-01",
    "courseName":"Bachelor of Theology",
    "courseCode":"BTH",
    "duration":"24 months",
    "fees":7000,
    "courseOption":"Correspondence",
    "payOption":"Full",
    "feesOpted":7000
  },{
    "courseID":"VJD-05",
    "courseName":"Regular Theology (Diploma)",
    "courseCode":"RTD",
    "duration":"24 months",
    "fees":7000,
    "courseOption":"Correspondence",
    "payOption":"Full",
    "feesOpted":7000
  },{
    "courseID":"VJD-02",
    "courseName":"One Year Theology Course",
    "courseCode":"OYT",
    "duration":"12 months",
    "fees":7000,
    "courseOption":"Correspondence",
    "payOption":"Full",
    "feesOpted":7000
  },{
    "courseID":"VJD-03",
    "courseName":"Licentiate in Sacred Theology (M.Th)",
    "courseCode":"LTH",
    "duration":"24 months",
    "fees":7000,
    "courseOption":"Correspondence",
    "payOption":"Full",
    "feesOpted":7000
  },{
    "courseID":"VJD-04",
    "courseName":"Doctorate of Theology",
    "courseCode":"DTH",
    "duration":"24 months",
    "fees":7000,
    "courseOption":"Correspondence",
    "payOption":"Full",
    "feesOpted":7000
  }]
  
  export const fieldWorkList=[{
    id:1,
    field:"Hospitals",
    imageSrc:require('./assets/poster/hospital.jpeg')
  },{
    id:2,
    field:"Moving to Public Place",
    imageSrc:require('./assets/poster/publicplace.jpeg')
  },{
    id:3,
    field:"Parish",
    imageSrc:require('./assets/poster/parish.jpeg')
  },{
    id:4,
    field:"Prison",
    imageSrc:require('./assets/poster/TiharJail.jpeg')
  },{
    id:5,
    field:"SAMAG",
    imageSrc:require('./assets/poster/slumChildren.jpeg')
  },{
    id:6,
    field:"Tribal",
    imageSrc:require('./assets/poster/tribalPeople.jpeg')
  },{
    id:7,
    field:"Urban Poor",
    imageSrc:require('./assets/poster/streetChildren.jpeg')
  },{
    id:8,
    field:"Youth",
    imageSrc:require('./assets/poster/youth.jpeg')
  }]

  export const mainFieldWorkList=[{
    id:1,
    field:"Hospitals",
    imageSrc:require('./assets/poster/hospital.jpeg')
  },{
    id:2,
    field:"Moving to Public Place",
    imageSrc:require('./assets/poster/publicplace.jpeg')
  },{
    id:3,
    field:"Parish",
    imageSrc:require('./assets/poster/parish.jpeg')
  },{
    id:4,
    field:"Prison",
    imageSrc:require('./assets/poster/TiharJail.jpeg')
  },{
    id:5,
    field:"SAMAG",
    imageSrc:require('./assets/poster/slumChildren.jpeg')
  },{
    id:6,
    field:"Tribal",
    imageSrc:require('./assets/poster/tribalPeople.jpeg')
  },{
    id:7,
    field:"Urban Poor",
    imageSrc:require('./assets/poster/streetChildren.jpeg')
  },{
    id:8,
    field:"Youth",
    imageSrc:require('./assets/poster/youth.jpeg')
  }]

export const AVEList=[{
    id:"ave1",
    author:"Abraham, K.A.",
    book:"Rethinking Hope: Christian Eschatology Rediscovered.",
    year:"2021",
    publisher:"Delhi: Christian World Imprints",
    poster:require("./assets/poster/ave1.jpeg"),
   authorPic:require('./assets/images/defaultAvatar.jpg')

  },{
    id:"poster2",
    author:"Abraham, Molly",
    book:"A Saga of Tolerance and a Legacy for Posterity: Catholic Visionaries and Women’s Empowerment in North India.",
    year:"2021",
    publisher:"Delhi: ISPCK",
    poster:require("./assets/poster/ave2.jpeg"),
   authorPic:require('./assets/images/defaultAvatar.jpg')
  }];

export const VJTodayList=[{
  id:20,
  issue:"Issue 20",
  title:"VJ Today",
  issueYear:"2023",
  issueMonth:"Dec",
},{
    id:19,
    issue:"Issue 19",
    title:"VJ Today",
    issueYear:"2023",
    issueMonth:"Oct - Dec",
  },{
    id:18,
    issue:"Issue 18",
    title:"VJ Today",
    issueYear:"2023",
    issueMonth:"Apr",
  },{
    id:17,
    title:"VJ Today",
    issue:"Issue 17",
    issueYear:"2022",
    issueMonth:"Oct - Dec",
  },{
    id:16,
    title:"VJ Today",
    issue:"Issue 16",
    issueYear:"2022",
    issueMonth:"July - Sep",
  },{
    id:15,
    title:"VJ Today",
    issue:"Issue 15",
    issueYear:"2022",
    issueMonth:"Jan - Apr",
  },{
    id:14,
    title:"VJ Today",
    issue:"Issue 14",
    issueYear:"2021",
    issueMonth:"Oct - Dec",
  },{
    id:13,
    title:"VJ Today",
    issue:"Issue 13",
    issueYear:"2021",
    issueMonth:"July - Sep",
  },{
    id:12,
    title:"VJ Today",
    issue:"Issue 12",
    issueYear:"2021",
    issueMonth:"Jan - Mar",
  },{
    id:11,
    title:"VJ Today",
    issue:"Issue 11",
    issueYear:"2020",
    issueMonth:"Oct - Dec",
  },{
    id:10,
    title:"VJ Today",
    issue:"Issue 10",
    issueYear:"2020",
    issueMonth:"July - Sept",
  },{
    id:9,
    title:"VJ Today",
    issue:"Issue 9",
    issueYear:"2020",
    issueMonth:"Jan - Mar",
  },{
    id:8,
    title:"VJ Today",
    issue:"Issue 8",
    issueYear:"2019",
    issueMonth:"Oct - Dec",
  },{
    id:7,
    title:"VJ Today",
    issue:"Issue 7",
    issueYear:"2019",
    issueMonth:"July - Sept",
  },{
    id:6,
    title:"VJ Today",
    issue:"Issue 6",
    issueYear:"2019",
    issueMonth:"Jan - Mar",
  },{
    id:5,
    title:"VJ Today",
    issue:"Issue 5",
    issueYear:"2018",
    issueMonth:"Oct - Dec",
  },{
    id:4,
    title:"VJ Today",
    issue:"Issue 4",
    issueYear:"2018",
    issueMonth:"July - Sept",
  },{
    id:3,
    title:"VJ Today",
    issue:"Issue 3",
    issueYear:"2018",
    issueMonth:"Jan - Mar",
  },{
    id:2,
    title:"VJ Today",
    issue:"Issue 2",
    issueYear:"2017",
    issueMonth:"Oct - Dec",
  },{
    id:1,
    title:"VJ Today",
    issue:"Issue 1",
    issueYear:"2017",
    issueMonth:"July - Sept",
  }];

  export const TattvavivekaList=[{
    id:3,
    issue:"Tattvaviveka – 2018",
    title:"Tattvaviveka",
    issueYear:"2018",
    issueMonth:"Oct - Dec",
  },{
    id:2,
    issue:"Tattvaviveka – 2017",
    title:"Tattvaviveka",
    issueYear:"2017",
    issueMonth:"Apr",
  },{
    id:3,
    title:"Tattvaviveka",
    issue:"Tattvaviveka – 2016",
    issueYear:"2016",
    issueMonth:"Oct - Dec",
  }];

  export const visitingFacultyList=[{
    id:1,
    name:"Archbishop Anil J.T. Couto",
    title:"Rector",
    province:"DUM",
    subject:"Ecumenism",
    avatarSrc:require('./assets/photos/BishopAnil.png'),
    email:"rectorvj@gmail.com"
  },{
    id:2,
    name:"Bp. Deepak Tauro",
    title:"Registrar & Treasurer",
    province:"GUJ",
    subject:"Spirituality of Prayer",
    avatarSrc:require('./assets/photos/defaultAvatar.jpg'),
    email:"vjregis@gmail.com"
  },{
    id:3,
    name:"Fr. Jesuraj",
    title:"Scripture",
    province:"CCU",
    subject:"Church History & Sys. Theology",
    avatarSrc:require('./assets/photos/priestAvatar2.png'),
    email:"sjvalan@gmail.com"
  },{
    id:4,
    name:"Fr. Jaimon Joseph",
    title:"Scripture",
    province:"BOM",
    subject:"Church in the Middle Ages",
    avatarSrc:require('./assets/photos/priestAvatar2.png'),
    email:"edwinrods@gmail.com"
  },{
    id:5,
    name:"Fr. George Manimala",
    title:"Systematic Theology",
    province:"AND",
    subject:"Marriage Law & Parish Law",
    avatarSrc:require('./assets/photos/priestAvatar2.png'),
    email:"principalvj@gmail.com"
  },{
    id:6,
    name:"Fr. Cyprian Creado",
    title:"Moral Theology",
    province:"AND",
    subject:"Bio – Medical Ethics",
    avatarSrc:require('./assets/photos/priestAvatar2.png'),
    email:"stanallasj@gmail.com"
  },{
    id:7,
    name:"Fr. Nishant",
    title:"Systematic Theology",
    province:"DEL",
    subject:"Sociology of Religion",
    avatarSrc:require('./assets/photos/priestAvatar2.png'),
    email:"victoredwinsj@gmail.com"
  },{
    id:8,
    name:"Fr. Emmanuel Arockiam",
    title:"Scripture",
    province:"PAT",
    subject:"Pastoral Counselling",
    avatarSrc:require('./assets/photos/priestAvatar2.png'),
    email:""
  },{
    id:9,
    name:"Sr. Rani Punnaseril",
    title:"Counselor",
    province:"MAP",
    subject:"Indian Constitution",
    avatarSrc:require('./assets/photos/SisterAvatar.jpeg'),
    email:"leanderxalxosj@gmail.com"
  },{
    id:10,
    name:"Fr. Joe Francis",
    title:"Counselor",
    province:"KOH",
    subject:"Early Xtny & Patroogy",
    avatarSrc:require('./assets/photos/priestAvatar2.png'),
    email:"bonids@gmail.com"
  },{
    id:11,
    name:"Fr. Devanmitra Neelankavil",
    title:"Systematic Theology",
    province:"KAR",
    subject:"Oriental Theology",
    avatarSrc:require('./assets/photos/priestAvatar2.png'),
    email:"anilksha@gmail.com"
  },{
    id:12,
    name:"Fr. Arjen Tete",
    title:"Scripture",
    province:"KOH",
    subject:"Pneumatology",
    avatarSrc:require('./assets/photos/priestAvatar2.png'),
    email:"jameskulvi@gmail.com"
  },{
    id:13,
    name:"Fr. Shantharaj",
    title:"On Sabbatical",
    province:"AND",
    subject:"Ecclesiology",
    avatarSrc:require('./assets/photos/priestAvatar2.png'),
    email:""
  },{
    id:14,
    name:"Fr. Praseed IMS",
    title:"On Sabbatical",
    province:"AND",
    subject:"Symbols & sacraments",
    avatarSrc:require('./assets/photos/priestAvatar2.png'),
    email:""
  },{
    id:15,
    name:"Fr. Domy MSFS",
    title:"On Sabbatical",
    province:"AND",
    subject:"Canon Law – General Terms",
    avatarSrc:require('./assets/photos/priestAvatar2.png'),
    email:""
  },{
    id:16,
    name:"Fr. Sahayaraj",
    title:"On Sabbatical",
    province:"AND",
    subject:"Human & Christian Virtues",
    avatarSrc:require('./assets/photos/priestAvatar2.png'),
    email:""
  },{
    id:17,
    name:"Sr. Antonetta Pereira",
    title:"On Sabbatical",
    province:"AND",
    subject:"Mariology",
    avatarSrc:require('./assets/photos/SisterAvatar.jpeg'),
    email:""
  },{
    id:18,
    name:"Sr. Margret",
    title:"On Sabbatical",
    province:"AND",
    subject:"Feminist Questions",
    avatarSrc:require('./assets/photos/SisterAvatar.jpeg'),
    email:""
  },{
    id:19,
    name:"Ms. Grace David",
    title:"On Sabbatical",
    province:"AND",
    subject:"Theology of Laity",
    avatarSrc:require('./assets/photos/defaultAvatar.jpg'),
    email:""
  },{
    id:20,
    name:"Fr. John Chathanatt",
    title:"On Sabbatical",
    province:"AND",
    subject:"Social teaching of the Church",
    avatarSrc:require('./assets/photos/priestAvatar2.png'),
    email:""
  },{
    id:21,
    name:"Fr. Bosco",
    title:"On Sabbatical",
    province:"AND",
    subject:"Dalit Questions",
    avatarSrc:require('./assets/photos/priestAvatar2.png'),
    email:""
  },{
    id:22,
    name:"Sr. Rashmi Kindo",
    title:"On Sabbatical",
    province:"AND",
    subject:"Tribal Questions",
    avatarSrc:require('./assets/photos/SisterAvatar.jpeg'),
    email:""
  },{
    id:23,
    name:"Sr. Nija Vara, MF",
    title:"On Sabbatical",
    province:"AND",
    subject:"Documents of Vatican II",
    avatarSrc:require('./assets/photos/SisterAvatar.jpeg'),
    email:""
  },{
    id:24,
    name:"Fr. Ravisekhar Dusi",
    title:"On Sabbatical",
    province:"AND",
    subject:"Pastoral Liturgy",
    avatarSrc:require('./assets/photos/priestAvatar2.png'),
    email:""
  }];

  export const officialsList=[{
    id:1,
    title:"Patron",
    subTitle:"Archbishop of Delhi",
    name:"Rt. Rev. Anil J. T. Couto",
    avatarSrc:require('./assets/photos/BishopAnil.png')
  },{
    id:2,
    title:"Chancellor",
    subTitle:"Superior General of S.J.",
    name:"Rev. Fr. Arturo Sosa SJ",
    avatarSrc:require('./assets/photos/arturo.jpg')
  },{
    id:3,
    title:"Vice- Chancellor",
    subTitle:"Provincial of South Asia",
    name:"Fr. Stanislaus D’Souza SJ",
    avatarSrc:require('./assets/photos/stanPOSA.jpg')
  },{
    id:4,
    title:"Rector",
    subTitle:"",
    name:"Fr. Nirmal Raj SJ",
    avatarSrc:require('./assets/photos/nirmalrector.JPG')
  },{
    id:5,
    title:"Principal",
    subTitle:"",
    name:"Fr. Rajakumar Joseph SJ",
    avatarSrc:require('./assets/photos/raj.JPG')
  },{
    id:6,
    title:"Treasurer",
    subTitle:"",
    name:"Fr. Hector Pinto SJ",
    avatarSrc:require('./assets/photos/hector.JPG')
  },
  {
    id:9,
    title:"Registrar & Librarian",
    subTitle:"",
    name:"Fr. Joseph Mathew SJ",
    avatarSrc:require('./assets/photos/joemathew.jpg')
  },
  {
    id:7,
    title:"Director of Post-Graduate Studies",
    subTitle:"",
    name:"Dr. Fr. Valan C. Antony SJ",
    avatarSrc:require('./assets/photos/valan.jpg')
  },{
    id:8,
    title:"Director of Fieldwork",
    subTitle:"",
    name:"Fr. Anil D’Almeida SJ",
    avatarSrc:require('./assets/photos/anil.jpg')
  },{
    id:10,
    title:"Administrator",
    subTitle:"",
    name:"Fr. Godfried Ekka SJ",
    avatarSrc:require('./assets/photos/godfried.jpg')
  },{
    id:11,
    title:"Director of DEPTh",
    subTitle:"",
    name:"Fr. Anil D’ Almeida SJ",
    avatarSrc:require('./assets/photos/anil.jpg')
  },{
    id:12,
    title:"Director of VIDIS",
    subTitle:"",
    name:"Fr. J. Victor Edwin SJ",
    avatarSrc:require('./assets/photos/victoredwin.JPG')
  },{
    id:13,
    title:"Editor of Vidyajyoti Journal",
    subTitle:"",
    name:"Dr. Fr. Edwin Rodrigues SJ",
    avatarSrc:require('./assets/photos/FrEdwin.jpg')
  }];

  export const residentialFacultyList=[
    {
    id:1,
    title:"Principal",
    subTitle:"",
    name:"Dr. Fr. Rajakumar Joseph SJ",
    category:"Systematic Theology & Principal",
    avatarSrc:require('./assets/photos/RajKumarFrSJ.jpeg'),
    dob:"07-07-1971",
    pob:"Tuticorin, Tamil Nadu",
    emailID:"rajkumarsj@gmail.com",
    contact:"08130263395",
    province:"Andhra Pradesh",
    academicQualification:[{
      degree:"Bachelor of Arts",
      year:"",
      college:"Andhra Loyola College, Vijayawada, A.P."
    },{
      degree:"Bachelor in Education (B.Ed.)",
      year:"",
      college:"St. Xavier’s College, Palayamkottai, T.N."
    },{
      degree:"Bachelor in Philosophy",
      year:"",
      college:"Jnana Deepa Vidyapeth, Pontifical Institute for Philosophy and Religion, Pune."
    },{
      degree:"Bachelor in Theology (B.Th.)",
      year:"",
      college:"VidyaJyoti College of Theology, Delhi."
    },{
      degree:"Licentiate (STL)",
      year:"",
      college:"Jnana Deepa Vidyapeth, Pontifical Institute for Philosophy and Religion, Pune."
    },{
      degree:"Masters in Political Science",
      year:"",
      college:"Madurai Kamaraj University, T.N."
    },{
      degree:"Masters in Business Administration (MBA) in Human Resource Management",
      year:"",
      college:"Annamalai University, Chidambaram, T.N."
    },{
      degree:"Doctorate in Theology (Th.D.)",
      year:"",
      college:"Johannes Gutenberg University, Mainz, Germany."
    }
  ],
  booksPublished:[{
    details:"Rediscovering Rebirth and Discipleship in Baptism, (Bengaluru: ATC Publications, 2017)"
  },{
    details:"Culture and Spirituality, Edited, Vol I, (Delhi: ISPCK, 2021)"
  },{
    details:"Musings on Gandhian Thoughts, Edited, Vol. II, (Delhi: ISPCK, 2021)"
  },{
    details:"Pandemic Challenges to the Indian Church: A Theological Response, Edited, (Bangalore: ATC, 2024)."
  }],
  researchArticles:[{
    details:"“Liberalisation: Its Human Face?”, in Journal of Jnana Deepa Vidyapeeth, (February, 1998): 21-31."
  },{
    details:"“Take off Your Shoes”, Vidyajyoti Journal of Theological Reflection Vol. 71, no.9 (September 2007): 672-678."
  },{
    details:"“Take off Your Shoes”, Ek Sankramana Vol. 34, no. 3 (March, 2008): 88-92. (Republished in a Marati magazine)."
  },{
    details:"“Kenosis: The Way to Fullness of Life”, Vidyajyoti Journal of Theological Reflection Vol. 72, no.9 (September 2008): 700-704."
  },{
    details:"“Together To-Gather in the Eucharist.” Vidyajyoti Journal of Theological Reflection Vol.73, no.5 (May 2009): 381-387."
  },{
    details:"“Eucharistic Mission: To Bless and Break, Share and Serve & Wash and Wither.” Ephrem’s Theological Journal. Vol.13. no. 2, (October 2009): 167-174."
  },{
    details:"“Jesuits – With the Church for a Cause: Magis or Mediocrity”, Jeevan, 2001."
  },{
    details:"“Changing with Change: A Story on Personal Management, Sandhya, (March, 2003): 70-74."
  },{
    details:"“Mercy: A Call to Radical Discipleship,” Vidyajyoti Journal of Theological Reflection Vol.80, no.11 (November 2016): 843-863."
  },{
    details:"“Reinventing Religious Life: The Challenge of Pope Francis,” in Pope Francis His Impact on and Relevance for the Church and Society, Edit., Kuruvilla Pandikattu, (New Delhi: Jnana Deepa Vidyapeeth and Christian World Imprints, 2018), 137- 152."
  },{
    details:"“Ministerial Priesthood and Integral Formation: Revisiting Ratio Fundamentalis Institutionis Sacerdotalis”, Vidyajyoti Journal of Theological Reflection Vol.83, no.1 (January 2019): 24-47."
  },{
    details:"“The Seeds of Religious Pluralism in the Writings of Thomas Aquinas and Michael Amaladoss,” in Eine Autorität für die Dogmatik?, Edit. Benjamin Dahlke/Bernhard Knorn, (Freiburg: Herder, 2018), 226 – 240."
  },{
    details:"“Covenantal Call and Eucharistic Engagement,” in In His Foot Steps: A festschrift for Jojaiah, (Delhi: ISPCK, 2019), 112-118."
  },{
    details:"“Suffering and Hope Amidst Corona Pandemic: A Theological Search for Spiritual Vaccine,” Vidyajyoti Journal of Theological Reflection, Vol. 84, no.10 (October 2020): 721 -743."
  },{
    details:"O Herr, Öffne Unsere Augen (2 Könige 6:15-17)“ in Missio Journal, Aachen, Germany, 2021."
  },{
    details:"“Integral Mission Today: Perspectives for New Evangelization”, Vidyajyoti Journal of Theological Reflection, Vol. 85, no.4 (April, 2021): 300-308."
  },{
    details:"“No Synodality without the Theology of Communion” in No Synodality Without, edited by P. R. John, (Delhi: ISPCK & Vidyajyoti, 2022), 118-128."
  },{
    details:"“Illumination and Regeneration: Biblical-Metaphorical Insights into Baptism”, Vidyajyoti Journal of Theological Reflection, Vol. 86, no.7 (July, 2022): 503-521."
  },{
    details:"“To Live Liturgy Fully: Liturgical and Theological Insights from Desiderio Desideravi,” Vidyajyoti Journal of Theological Reflection, Vol. 87, no.2 (February, 2023): 138-152."
  },{
    details:"“Teilhardian Spirituality for Cosmic Eucharist”, National Monthly for Christian Leadership: Companion, Vol.13, No. 6, (June, 2023): 9-11."
  },{
    details:"“Christian Sacraments” in Christianity: Encyclopedia of Indian Religions, (London: Springer Publication: 2023)."
  },{
    details:"“Living the Missionary Discipleship”, National Monthly for Christian Leadership: Companion, Vol. 13, No.7, (July, 2023): 17-20."
  },{
    details:"“Gandhian Sarvodaya and Samabhava as Talking Points for Social Covenant”, Editorial, Vidyajyoti Journal of Theological Reflection, Vol. 87, No. 10, (October, 2023): 721-725."
  },{
    details:"“Stan swamy’s bagaicha – for an inclusive society” in Vidyajyoti Today, Vol. 19, (October: 2023), 4-5."
  },{
    details:"“Wounded World Needs Wisdom of Choice”, in Vidyajyoti Today, Vol. 20, (December: 2023), 4-5."
  },{
    details:"“New Leaves in Theology as the New Wine”, Vidyajyoti Journal of Theological Reflection, Vol. 88, No. 1, (January, 2024): 65-73."
  },{
    details:"“Outgoing-Pilgrim Church with a Difference”, Vidyajyoti Journal of Theological Reflection, Vol. 88, No.2, (February, 2024): 151- 158."
  },{
    details:"“St. Joseph: ‘A Minister of Salvation’”, Vidyajyoti Journal of Theological Reflection, Vol. 88, No. 3, (March, 2024): 224-231."
  },{
    details:"“Resurrection Paradigms for Life”, Vidyajyoti Journal of Theological Reflection, Vol. 88, No. 4, (March, 2024): 302-310."
  },{
    details:"“God’s Ballot Box”, in Vidyajyoti Today, Vol. 21, (April: 2024), 4-5."
  },{
    details:"“Renewed Sacramental Tapestry for Today” in Vidyajyoti Journal of Theological Reflection, Vol. 88, No. 7, (July, 2024): 551-560."
  },{
    details:"“No Need of Functionary Priests” in Vidyajyoti Journal of Theological Reflection, Vol. 88, No. 8, (August, 2024): 627-635."
  },{
    details:"“Mary, The Rainbow Lifting us to God – Part I” in Vidyajyoti Journal of Theological Reflection, Vol. 88, No. 9, (Sep, 2024): 701-709."
  },{
    details:"“Reimagining: A Global and Indian Perspective”, in Vidyajyoti Today, Vol. 22, (April: 2024), 1-2."
  },{
    details:"“Mary, The Rainbow Lifting us to God – Part II” in Vidyajyoti Journal of Theological Reflection, Vol. 88, No. 11 (Nov, 2024): 863-874."
  }],
  generalArticles:[{
    details:"Good Samaritans of our time - Indian Express, 5th March, 1993, Vijayawada."
  },{
    details:"Education At Crossroads - Deccan Chronicle, July, 1993, Vijayawada."
  },{
    details:"A Rally for Equal Rights - Jivan, September, 1994."
  },{
    details:"Aids-Myth & reality - Indian Express, 25th April 1993, Vijayawada."
  },{
    details:"The dead can help too - Indian Express, April-07, 1994, Vijayawada."
  },{
    details:"Electoral Reforms- a signpost - Indian Express, Dec-01, 1994, Vijayawada."
  },{
    details:"Woman- a mere baby-producing machine? - Indian Express, March, 9th 1995, Vijayawada."
  },{
    details:"Ballot Must Win over Bullet - Indian Express- 20th February, 1998, Pune."
  },{
    details:"A Secular State? - Indian Express, Pune- 15th Jan., 1998."
  },{
    details:"A Rally for Equal Rights - Jivan-September, 1994."
  },{
    details:"Kohima’s Kohinoor: Diamond Jubilee of Fr. Ligoury Castelino - Kohima Newsletter, 15 July, 2000."
  },{
    details:"Christmas and Christ-Management - Andhra Scholastics Report, 2000."
  },{
    details:"Is it Rational to Pray for Rain? Letter to the Editor in ‘The Hindu’ - ‘The Hindu’, Letter to the Editor, 14th August, 2002. Delhi."
  },{
    details:"Bringing Fresh Air into classrooms - Indian currents, 4th August, 2002, 40-42."
  },{
    details:"The ‘One Thing’: Integrity, Prophetic and Servant Leadership - Tattvavika, 2008, 9-10."
  },{
    details:"Birth of Hope to Heal the World - Jivan, 2020-2021, 12-13."
  },{
    details:"Vidyajyoti at the Service of Theological Formation - Jivan, Feb. 2023, 7-8."
  }],
  bookReviews:[{
    details:"Charles E. Farhadian. Christian Worship Worldwide: Expanding Horizons, Deepening Practices., Cambridge, Eerdmans Publishing Co. 2007. In Vidyajyoti Journal of Theological Reflection, Vol. 72, No. 11, November 2008, (871-872)."
  },{
    details:"Kevin Burke. PEDRO ARRUPE, Essential Writings. New York, Maryknoll, Orbis Books, 2005. In Vidyajyoti Journal of Theological Reflection, vol. 71, No. 11, November 2007, (829-830)."
  },{
    details:"Daniel Castelo, Pentecostalism As A Christian Mystical Tradition, (Michigan: William B. Eerdmans Publishing Company, 2017). In Vidyajyoti Journal of Theological Reflection, vol. 82, No. 9, September 2018, (719-720)."
  },{
    details:"Hermann Roborgh and Joseph Victor Edwin SJ editors, Witness to a Common Hope, (Anand: Gujarat Sahitya Prakash, 2022). In Vidyajyoti Journal of Theological Reflection, to be published in March."
  }],
 
    currentTeaching:"Principal, Professor of Systematic Theology",
    previousTeaching:[{
      details:"Director of Distance Education Programme (DEPTh)",
      year:"2016-2023"
    }],
  },{
    id:12,
    title:"Registrar",
    subTitle:"",
    name:"Dr. Fr. Joseph Mathew Vayalilkalappura SJ",
    category:"Systematic Theology",
    emailID:"jmvayalilsj@yahoo.com",
    contact:"",
    province:"Kerala",
    currentTeaching:"Registrar, Librarian, Lecturer - Systematic Theology",
    academicQualification:[{
      degree:"M.Sc. Botany",
      year:"",
      college:"University of Kerala"
    },{
      degree:"M. Phil. in Plant Tissue Culture",
      year:"",
      college:"University of Bharathedasan, Tiruchirappalli, TN."
    },{
      degree:"STL",
      year:"",
      college:"Oriental Institute, Rome"
    },{
      degree:"Ph. D. in Ecological Theology",
      year:"",
      college:"St. Joseph’s Pontifical Institute, Alwaye, Kerala"
    }
  ],
   previousTeaching:[{
      details:"Professor of Botany & Biotechnology - St. Xavier's College, Thumba, Trivandrum",
      year:""
    },{
      details:"Founder Director Xavier-Trombetti Institute of Applied Biology, St. Xavier’s College, Thumba, Trivandrum",
      year:""
    },{
      details:"Undertook a major UGC project titled “Women Empowerment for Environmental Management – A Case Study of mushroom farming using Eicchornia Weeds as substrate”",
      year:""
    },{
      details:"Principal - St. Xavier's College, Thumba, Trivandrum",
      year:""
    },{
      details:"Principal - St. Xavier's College, Calicut",
      year:""
    },{
      details:"Rector & Manager – St. Xavier’s College, Thumba, Trivandrum",
      year:""
    }],
    booksPublished:[{
    details:"Pourohitya Vazhikal (edt.) – 2009"
  },{
    details:"Ecological mission of the Church in the Contemporary World -2012"
  },{
    details:"Green Model of the Church – 2018"
  }],
    avatarSrc:require('./assets/photos/FrJoseMathew.jpg')
  },{
    id:2,
    title:"Director of Post-Graduate Studies",
    subTitle:"",
    emailID:"sjvalan@gmail.com",
    province:"Kolkata",
    name:"Dr. Fr. Valan C. Antony SJ",
    category:"Scripture",
    currentTeaching:"Professor of Sacred Scriptures",
    previousTeaching:[{
      details:"Tutor Scripture Studies",
      year:"2005-2008"
    },{
      details:"Director of Fieldwork",
      year:"2005-2009"
    },{
      details:"Staff Guide for AVE",
      year:"2005-2009 & 2014-2015"
    },{
      details:"Lecturer, Scripture Studies",
      year:"2008-2013"
    },{
      details:"Associate Editor, Vidyajyoti Journal of Theological Reflection",
      year:"2015-2018"
    },{
      details:"Senate Member",
      year:"2015-2018"
    },{
      details:"Reader, Scripture Studies",
      year:"2015-2018"
    },{
      details:"Director of Post Graduate Studies",
      year:"2018-2024"
    },{
      details:"Staff Guide for the Parish Apostolate Group"
    },{
      details:"Academic Mentor"
    }],
    academicQualification:[{
      degree:"Graduation (BA English Literature)",
      year:"",
      college:"St. Xavier’s College, Kolkata."
    },{
      degree:"Philosophy (B.Ph.)",
      year:"",
      college:"Jnana Deepa Vidyapeeth, Pune."
    },{
      degree:"Post-Graduation: MA English Literature",
      year:"",
      college:"Loyola College, Chennai (Gold Medallist; 1995)."
    },{
      degree:"B.Th. Degree",
      year:"",
      college:"Vidyajyoti, 4A, Raj Niwas Marg, Delhi. Distinction (October 2000)."
    },{
      degree:"SSL Degree",
      year:"",
      college:"Pontificio Istituto Biblico, Rome, 2001-2005. (Distinction)."
    },{
      degree:"Hebrew Studies",
      year:"",
      college:"Rothberg International School of Jewish Studies, Jerusalem 2002-2003 (Distinction)."
    },{
      degree:"STD",
      year:"",
      college:"Jesuit School of Theology of Santa Clara University (Berkeley Campus), USA (2010-2013) – Distinction."
    }],
    generalArticles:[{
      details:"“Passions of Pedro Arrupe,” VJTR 71 (November, 2007): 812-822."
    },{
      details:"“Paul’s Encounter with the Risen Lord,” VJTR 72 (January, 2008): 70-75."
    },{
      details:"“Rejoice in the Lord always: Phil 4:4,” VJTR 72 (June, 2008): 476-480."
    },{
      details:"“Prayer: The Power that Permeated Paul,” in Paul for Our Time, ed. Antonette Jesumani fsp (Mumbai: Pauline Sisters Bombay Society, 2008): 54-56."
    },{
      details:"“Let Us Unlock the Doors of Hope,” Editorial, VJTR 77 (December, 2013): 1-4."
    },{
      details:"“Ashun amra aashar rudhe duar abarito kori,” Bangla Herald 117 (January, 2014): 14–15."
    },{
      details:"“Tomra Probhur shannidhe nitho anonde thako, abar boli, anondei thako,” Bangla Herald 119 (June-July, 2014): 2-4."
    },{
      details:"“Punoruthan – amader shorbottom o shorboprodhan porbo,” Bangla Herald 118 (April – May, 2014): 7."
    },{
      details:"“En Christō (“in Christ”) - The Theological Matrix of Philemon,” VJTR 79 (February, 2015): 100-117."
    },{
      details:"“Dei Verbum – A Revisit,” VJTR 79 (February, 2015): 137-142."
    },{
      details:"“Easter in a Challenging Context,” Editorial, VJTR 79 (March, 2015): 3-6."
    },{
      details:"“En Christō (“in Christ”) - The Theological Matrix of Philemon,” Part II, VJTR 79 (April, 2015): 276-291."
    },{
      details:"“En Christō (“in Christ”) - The Theological Matrix of Philemon,” Part III, VJTR 79 (May, 2015): 380-392."
    },{
      details:"“Pauline Perspectives on Marriage as in Ephesians,” in Marriage and Family Today: An Indian Theological Search. Eds. Asrid Lobo Gajiwala and Vincent Kundukulam (Bangalore: ATC, 2015)."
    },{
      details:"“Mercy, the Heartbeat of God,” Ignis, vol. XLVI, no.1, (2016): 7-20."
    },{
      details:"“Saint Teresa of Kolkata: A Marvellous Marvel,” VJTR, Editorial, vol.80, no.9, September (2016): 642-644."
    },{
      details:"“Hop into 2017… with Hope,” VJTR, Editorial, vol. 81, no.1, January (2017): 5-7."
    },{
      details:"“Youth, the ‘Now’ of God,” Editorial, VJTR 83 (March, 2019): 3-7."
    },{
      details:"“Joy… Jesus … Jojayya,” in In His Footsteps, a Festschrift in honour of Fr. Jojayya Pudota, S.J., ed. P. R. John (Delhi: ISPCK, 2019), 52-60."
    },{
      details:"“Coping with COVID-19,” Editorial, VJTR 84 (June, 2020): 3-8."
    },{
      details:"“Option for the Least: a Biblical perspective,” in Cenkāntal (Bulletin of the Spirituality and Dialogue Commission, Chennai Jesuit Province), no. 3 (March, 2021), 5-6."
    },{
      details:"“Scripture and Synodality,” in No Synodality Without… Ed. by P. R. John (ISPCK, Delhi: Vidyajyoti College of Theology, 2022), 30-43."
    },{
      details:"“JUDITH AND DEVI-MAHATMYA: An Inter-Faith Comparative Reading,” VJTR 86 (October, 2022): 741-750."
    },{
      details:"“To Script a New Beginning,” Jivan (November- December, 2023): 7."
    },{
      details:"“Reconciliation – Biblical Foundations Towards Realizing God’s Kingdom,” to be published soon by Vidyajyoti College of Theology, Delhi."
    },{
      details:"“Hoping High,” VJTR, Editorial, vol. 89, no.1, January (2025): 5-9."
    },{
      details:"“The Hermeneutical Style of Vantana Mataji,” for the Oxford Handbook of the Bible in India to be published by Oxford University Press in December(?), 2025."
    }],  
    bookReviews:[{
      details:"Paddy Fields and a Grain of Rice, by Paddy Meagher, S. J., VJTR 71, no. 6 (2007):469-471."
    },{
      details:"The Gospel of Mark: A Socio-Rhetorical Commentary, by Ben Witherington III, VJTR 71, no. 8 (2007): 631-633."
    },{
      details:"The Gospel of Matthew: A Commentary on the Greek Text, by John Nolland, VJTR 71, no. 9 (2007):709."
    },{
      details:"The Survivors of Israel: A Reconsideration of the Theology of Pre-Christian Judaism, by Mark Adam Elliott, VJTR 71, no. 11 (2007): 856-857."
    },{
      details:"Diversity in Paul’s Eschatology: Paul’s View on the Parousia and Bodily Resurrection, by S. Sobanaraj, VJTR 72, no. 5 (2008): 392-394."
    }],
    avatarSrc:require('./assets/photos/valan.jpg')
  },{
    id:3,
    title:"Editor of Vidyajyoti Journal",
    subTitle:"",
    name:"Dr. Fr. Edwin Rodrigues SJ",
    category:"Scripture",
    emailID:"edwinrods@gmail.com",
    province:"",
    currentTeaching:"Editor of VJTR and Secretary of VIEWS",
    previousTeaching:[{
      details:"Lecturer, Sacred Scripture"
    },{
      details:"Librarian (2021-2022) Vidyajyoti College"
    }],
    academicQualification:[{
      degree:"Diploma in Mechanical Engineering",
      year:"1995-1998",
      college:"Bhausaheb Vartak Polytechnic"
    },{
      degree:"BA in Social Sciences",
      year:"2001-2003",
      college:"Tilak Maharashtra Vidyapeeth, Gul Tekdi, Pune (distance education): Gold Medallist."
    },{
      degree:"MA in Philosophy: Sacred Heart College, Satya Nilayam (M.A. Philosophy through Dept, of Philosophy",
      year:"2003-2005",
      college:"Loyola College, Chennai): Gold Medallist."
    },{
      degree:"MA in Economics",
      year:"2005-2007",
      college:"Department of Economics, Bombay University"
    },{
      degree:"Bachelors in Theology",
      year:"2008-2011",
      college:"Vidyajyoti College of Theology, Delhi  "
    },{
      degree:"Licentiate: Masters in Biblical Studies",
      year:"2012-2014",
      college:"Jnana Deepa Vidyapeeth, Pune"
    },{
      degree:"PhD in Old Testament Exegesis",
      year:"2017-2021",
      college:"Philosophische-Theologische Hochschule, Sankt Georgen, Frankfurt, Germany."
    }],
    generalArticles:[{
      details:"“Biblical Foundations of Synodality: Theological Reflection on Journeying Together and Listening,” in Synodality: An Indian Theological Reflection, ed. Edwin Rodrigues (ATC: Bengaluru, 2024), 20-47."
    },{
      details:"“What Does the Lord Require of You? Reconciling the Polarities,” in The Role of Theology in Nation-Building, ed. Edwin Rodrigues SJ (VCT/ISPCK: Delhi, 2024), 298-306."
    },{
      details:"“Bible,” in Christianity: Encyclopaedia of Indian Religions, ed. John Chattanatt SJ (Springer: 2023), 154-163."
    },{
      details:"“Blessed (Baruk) Deity and Blessed (Ashre) Devotee: A Theological Reflection on Blessing in the Book of Psalms,” in Called to Be a Blessing: International Festschrift in honour of Dr. Jacob Kavunkal SVD, eds. K. Jose SVD and C. Tauchner SVD (Bhubneshwar et al.: Global Publishing House India, 2023), 115-136."
    },{
      details:"“Ignatius Standing in the Breach: An Ignatian and Contextual Theological Reflection on Ps 106:23 and Ezek 22:30,” in Re-discovering Inigo the Pilgrim in South Asianness, ed. Elil Rajendram SJ (Delhi: ISPCK, 2023), 79-104."
    },{
      details:"“No Synodality without the Theology of Reconciliation,” in No Synodality without..., ed. P.R. John (Delhi: ISPCK/VCT, 2022), 129-146."
    },{
      details:"“Bombay Jesuits’ Contribution to the Empowerment of Warlis,” in Jesuit Contribution to Nation Building in South Asia, ed. Leonard Fernando (Anand: GSP, 2019), 187-201."
    },{
      details:"“Psalm 34: Humble and Grateful Righteous’ Instruction on Salvation Experienced in the Lord,” VJTR 85/4 (Apr 2021): 269-286."
    },{
      details:"“Psalm 34: Humble and Grateful Righteous’ Instruction on Salvation Experienced in the Lord,” VJTR 85/4 (Apr 2021): 269-286."
    },{
      details:"“Tamar: The Woman who Opened the Eyes of Judah: An Exegetical Study of Gen 38:12-26,” VJTR 80/2 (Feb 2016): 21-33."
    },{
      details:"“Celebrating the Memory: The Proto-Commandment: Exegetical-Hermeneutical Study of Ex 12:14,” Jnana-Sanjeevani 2 (2014): 28-44."
    },{
      details:"“Revelation 9: The Trumpet Call to Repentance,” Jnana-Sanjeevani 1 (2013): 21-33."
    },{
      details:"“Prophetic Voice of Vasai: Tribute to Fr. Francis D’Britto,” The Examiner 68/33 (Aug 17-23, 2024): 11-12."
    },{
      details:"“Sr. Fidelis’ Complete Commitment to the Eucharistic Lord,” Voice of Delhi 32/9 (Sept 2023): 11-12."
    },{
      details:"“Sr. Fidelis’ Tender Devotion to Mother Mary,” Voice of Delhi 32/4 (Apr 2023): 10."
    },{
      details:"(Along with Rajkumar SJ), “Vidyajyoti at the Service of Theological Formation,” Jivan (February 2023): 07-08."
    },{
      details:"“Four Constitutions of Vatican II and Pope Francis’ Aggiomamento,” Voice of Delhi 32/2 (Feb 2023): 10-12."
    },{
      details:"“Open the Door: Reflection on Season of Advent,” Voice of Delhi 31/12 (Dec 2022): 8-9."
    },{
      details:"“Servant of God: Sr. Dr. Fidelis Thaliath SD,” Voice of Delhi 31/10 (Oct 2022): 12-13."
    }],
    editorials:[{
      details:"“Seeking the Hidden Face of God,” VJTR 88/11 (Nov 2024): 801-805."
    },{
      details:"“Loyal Love (Hesed) of the Lord and Acatamient of VJTR 88/9 (Sept 2024): 641-646."
    },{
      details:"“Stretch Out and Reach Out: Ways to Revive Our Withered Existence,” VJTR 88/8 (Aug 2024): 561-566."
    },{
      details:"“Towards Greater Civic Responsibility: Lessons from Gaudium et Spesf VJTR 88/7 (Jul 2024): 481-486."
    },{
      details:"“Religious Wonder and Beatific Vision: Tasting a Slice of Heaven on Earth,” VJTR 88/2 (Feb 2024): 81-86."
    },{
      details:"“Synodality at COP28: Abu Dhabi Interfaith Statement and Faith Pavilion,” VJTR 88/1 (Jan 2024): 3-9."
    },{
      details:"“Committing Ourselves to ‘a Fundamentally Contextual Theology,”’ VJTR 87/12 (Dec 2023): 881-886."
    },{
      details:"“A Way to Restore Shalom: Praying Psalms for Healing and Wholeness,” VJTR 87/11 (Nov 2023): 801-805."
    },{
      details:"“A Milestone in Francis Revolution: Appointment of the New Prefect of DDF,” VJTR 87/8 (Aug 2023): 561-565."
    },{
      details:"“Manipur Cries for Peace and Reconciliation,” VJTR 87/7 (July 2023): 481-484."
    },{
      details:"“Interrelated Web of Creation: Understanding the Biblical Roots of Cosmotheanthropism,” VJTR 87/6 (June 2023): 401-406."
    },{
      details:"“Eucharistic Encounter: Being Formed for the Eucharist and by The Eucharist,” VJTR 87/5 (May 2023): 321-326."
    },{
      details:"“Four Constitutions of Vatican II and Pope Francis’ Aggiomamento,” VJTR 87/1 (Jan 2023): 3-9."
    },{
      details:"“Lay-Clergy Collaboration: A Call for a Course Correction,” VJTR 86/11 (Nov 2022): 801 - 807."
    },{
      details:"“Arms Race and Arms Trade. Can More Arms Usher in More Peace?” VJTR 86/10 (Oct 2022): 721-725."
    },{
      details:"“Remember the Poor: Building the Future with Migrants and Refugees,” VJTR 86/9 (Sept 2022): 641-646"
    },{
      details:"“Let’s Keep the Legacy of Stan Swamy Burning Brightly,” VJTR 86/7 (July 2022): 481-485."
    },{
      details:"“Playing War and Peace,” VJTR 86/6 (June 2022): 401-404."
    },{
      details:"“Ten New Stars to Guide Our Paths towards Christ,” VJTR 86/5 (May 2022): 321-325."
    },{
      details:"“A Fragile Giant with Childlike Simplicity,” VJTR 86/4 (Apr 2022): 241-244."
    },{
      details:"“Abasement of a Prophet and Rising of a People,” VJTR 85/8 (Aug 2021): 561-565."
    }],
    manuscript:[{
      details:"Psalm of Praise for the Rescue of the Throat: Concatenation and lectio continua of Ps 33-34-35 (OBS 54; Peter Lang: Frankfurt, 2022)."
    }],
    editedVolumes:[{
      details:"Synodality: An Indian Theological Reflection (ATC: Bengaluru, 2024)."
    },{
      details:"The Role of Theology in Nation-Building (VCT/ISPCK: Delhi, 2024)."
    }],
    avatarSrc:require('./assets/photos/FrEdwin.jpg')
  },{
    id:4,
    title:"Editor of Vidyajyoti Journal",
    subTitle:"",
    name:"Fr. Stanislaus Alla SJ",
    category:"Moral Theology",
    emailID:"victoredwinsj@gmail.com",
    province:"Delhi",
    currentTeaching:"Lecturer - Systematic Theology & Islamic Studies",
    academicQualification:[{
      degree:"MA",
      year:"",
      college:""
    },{
      degree:"M.Phil",
      year:"",
      college:""
    },{
      degree:"M.Th",
      year:"",
      college:""
    },{
      degree:"Ph.D",
      year:"",
      college:""
    }],
    avatarSrc:require('./assets/photos/Stan.jpg')
  },{
    id:5,
    title:"Director of VIDIS",
    subTitle:"",
    name:"Dr. Fr. Joseph Victor Edwin SJ",
    emailID:"victoredwinsj@gmail.com",
    contact:"",
    province:"Delhi",
    category:"Systematic Theology & Christian-Muslim Dialogue",
    currentTeaching:"Lecturer, Systematic Theology & Islamic Studies",
     academicQualification:[{
      degree:"MA",
      year:"",
      college:""
    },{
      degree:"M.Phil",
      year:"",
      college:""
    },{
      degree:"M.Th",
      year:"",
      college:""
    },{
      degree:"Ph.D",
      year:"",
      college:""
    }
  ],
    avatarSrc:require('./assets/photos/victoredwin.JPG')
  },{
    id:6,
    title:"Director of Fieldwork",
    subTitle:"",
    name:"Fr. Anil D’Almeida SJ",
    category:"Systematic Theology",
    avatarSrc:require('./assets/photos/anil.jpg')
  },{
    id:7,
    title:"Director of Fieldwork",
    subTitle:"",
    name:"Dr. Fr. James B. Dabhi SJ",
    emailID:"jamesbdabhi@jesuits.net",
    province:"Gujarat (GUJ)",
    booksPublished:[{
    details:"“. . . Unless a Grain of Wheat falls into the Earth and dies . . .” Third Millennium vol. VI no. 1 (January-March 2003): 74-88."
  },{
    details:"“From Faith to Unfaith and Back: A Journey with God.” Third Millennium vol. VII no. 2 (April-June 2004): 80-88."
  },{
    details:"“”. . . because God that I am and not a Human . . .” (Hos. 11:9b): An Exegetical Study of Hos. 11: 1-9.” Bible Bhashyam vol. XXXII no. 2 (April-June 2006): 103-123."
  },{
    details:"“Was Paul Right?: Reconstructing the Issue narrated by Paul in Gal 2, 1-10.” Bible Bhashyam vol. XXXII no. 3 (July-September 2006): 225-244."
  },{
    details:"“Who is this YHWH in Jon 4:1-11?” Bible Bhashyam vol. XXXIII no. 2 (April-June 2007): 59-96."
  },{
    details:"“Either Choose or Lose: Synchronic and Diachronic Reading of Jos 24:1-33.” Bible Bhashyam volume XXXIII number 3 (July-September 2007): 40-81."
  },{
    details:"““. . . and (Abraham) took the knife; to kill his son:” The Characterization of Abraham in Gn. 22:1-19.” Bible Bhashyam vol. XXXIII no. 4 (October-December 2007): 3-41."
  },{
    details:"“Can Moses be interpreted as a Paradigmatic Leader?” Jeevadhara vol. XLII no. 248 (March 2012): 87-103."
  },{
    details:"“Trust in YHWH forever (Isa 26:4a): An Exegetical Study of Isa 26:1-6.” Bible Bhashyam vol. XXXIX no. 4 (October-December 2012): 248-290."
  },{
    details:"“Abraham: Our Father in Faith” Jeevadhara vol. XLIII no. 254 (March 2013): 87-101."
  },{
    details:"“Isayahka Granth: Pratham Bhag (Adhyay 1 se 39).” Pages 464-490 in Vald-Bulche Bible Bhashya, Edited by Subhash Anand. Delhi: Media House, 2018. (Commentary on Isaiah 1-39 in Hindi.)"
  },{
    details:"““. . . The young woman is with child . . .” (Isa 7:14b): A Study of Isa 7:1-25.” Bible Bhashyam vol. XXXIX no. 4 (October-December 2013): 208-236."
  },{
    details:"“The Poor in the Old Testament.” Jeevadhara vol. XLIV no. 260 (March 2014): 129-162."
  },{
    details:"“I am in the process of becoming a Jesuit.” DNC Times (2014)."
  },{
    details:"“A Theology Student in search of God at GVD.” GVD Magazine (2014)."
  },{
    details:"“Let us renew our commitment as Priests.” Third Millennium vol. XVII no. 2 (April-June 2014): 101-108."
  },{
    details:"“Let us renew our commitment as Priests.” Journal of St. Thomas Christians vol. 25 no. 2 (April-June 2014): 78-85."
  },{
    details:"“Four Measures to keep the Family Healthy.” Third Millennium vol. XVII no. 4 (October-December 2014): 88-93."
  },{
    details:"“The Mother of the Forsaken: Part I.” Third Millennium vol. XVIII no. 1 (January-March 2015): 89-101."
  },{
    details:"“The Mother of the Forsaken.” Journal of St. Thomas Christians vol. 26 no. 1 (January-March 2015): 86-111."
  },{
    details:"““Mortal can these bones live?”: A Study of Ezekiel 37:1-14 and its Relevance in Indian Context.” Journal of Indian Theology vol. VIII (January-April 2015): 33-46."
  },{
    details:"“Discipleship in Hebrew Bible.” Jeevadhara vol. XLV (March 2015): 51-65."
  },{
    details:"“The Mother of the Forsaken: Part II.” Third Millennium vol. XVIII no. 2 (April-June 2015): 60-70."
  },{
    details:"“Our Lady of Mount Carmel: Part I.” Third Millennium vol. XVIII no. 3 (July-September 2015): 78-92."
  },{
    details:"“Our Lady of Mount Carmel: Part II.” Third Millennium vol. XVIII no. 4 (October-December 2015): 84-99."
  },{
    details:"“My Confessor Fr. Moreta.” (Obituary.) Gujarat Jesuit Samachar (November 2015)."
  },{
    details:"“The Lord’s Extraordinary Mercy in the Hebrew Bible.” Jeevadhara vol. XLVI no. 272 (March 2016): 9-25."
  },{
    details:"“The Joy of My Mission.” Jivan (March 2016): 13."
  },{
    details:"“Resurrection through the Prism of Pope Francis’ Life.” DNC Times (April and May 2016): 4-5."
  },{
    details:"“Evangelization: Gospel Perspective.” Journal of Indian Theology vol. X no. 2 (May-August 2017): 79-91."
  },{
    details:"“Foolish Bridesmaid or Wise Bridesmaid?” Asian Journal of Religious Studies (October 2018)."
  },{
    details:"“Evangelization: Whose Need is it?” Third Millennium vol. XXI no. 4 (October-December 2018): 67-82."
  },{
    details:"“The Bible balances the Sacred and the Secular.” Jeevadhara vol. XLIX no. 290 (March 2019): 57-71."
  },{
    details:"“Do not worry about your life, what you would eat” (Luke 12:22c): A Study of Luke 12:22-34.” Bible Bhashyam vol. XXXXVI no. 1, 2 (January-June 2020): 22-47."
  },{
    details:"““. . . let it be with me according to your will” (Luke 1:38a).” Third Millennium vol. XXIII no. 2 (April-June 2020): 82-90."
  },{
    details:"“How can a Baptized Catholic become a Missionary?: Challenges of Maximum Illud and Vatican Council II.” Journal of Indian Theology XIII, 2 (May-August 2020): 47-71."
  },{
    details:"“Covenant.” VJTR vol. 84 no. 9 (September 2020): 644-661."
  },{
    details:"“Commemorating 100 Years of Arrival of the Spanish Missionaries.” The Ahmedabad Missionary no. 953-955 (October-December 2021):1-3."
  },{
    details:"“Commemorating 100 Years of Arrival of the Spanish Missionaries.” ALBOAN Journal (October-December 2021)."
  },{
    details:"“En Agradecimiento.” Jivan (November 2021)."
  },{
    details:"“Retreat for Diocesan Priests.” Pages 90-121 in To see All Things New in Christ: Eight Day Ignatian Retreats for Various Groups. Edited by Jose Panadan. Anand: Gujarat Sahitya Prakash, 2022."
  },{
    details:"““Go and Do likewise:” The Biblical Underpinnings of Fratelli Tutti.” Jnanadeepa vol. 26 no. 3 (July-September 2022): 78-98."
  },{
    details:"“Here am I, Send Me.” Third Millennium (2023)."
  },{
    details:"““Go and Do likewise:” The Biblical Underpinnings of Fratelli Tutti.” Pages 58-75 in Ethics, Sustainability and Fratelli Tutti: Towards a Just and Viable World Order Inspired by Pope Francis. Edited by Kuruvilla Pandikattu UK: Ethics International Press Ltd., 2022."
  },{
    details:"“Biblical Theology.” Pages 176-183 in Christianity: Encyclopedia of Indian Religions. Edited by John Chathanatt. The Netherlands: Springer Nature B. V., 2023."
  },{
    details:"“Courses ‘pierced my heart.’” Page 70 in Vidyajyoti: Institute of Religious Studies (Faculty of Theology): 1972-2022. Edited by Stanislaus Alla and Pravin Jose. Delhi: Vidyajyoti, 2023."
  },{
    details:"“Little Daughters of Saint Francis Xavier (LDFX).” Jivan (March 2023): 28-29."
  },{
    details:"“Father Joseph Valiamangalam, S.J. (1950 -2023).” (Obituary.) Third Millennium (2024)."
  },{
    details:"“Parables of the Kingdom of God in Matthew 13.” Pages 233-246 in Ripples of Wisdom: Essays in Honour of Prof. Dr. Selva Rathinam, SJ. JD-ISPCK Theological Publication Series Number 8. Edited by Thomas Karimundackal, Peter Ignatius, M. Paul Raj, Naveen Rebello, Gideon Warisa. Delhi: ISPCK, 2024."
  },{
    details:"“Swim against the Current.” A paper presented at Jesuit Theologians’ Forum at DNC, Pune, on 4th January 2025."
  }],
  bookReviews:[{
    details:"Kunnatholy Abraham. Church without Walls: A Biblico-Missiological Study based on St. Luke. Bangalore: Asian Trading Corporation, 2008, pages IX + 102. Third Millennium vol. XIII no. 4 (October-December 2010): 99-100."
  },{
    details:"Fallon Michael. The Gospel according to Matthew: An Introductory Commentary. Bangalore: Asian Trading Corporation, 2002, pages 395. Third Millennium vol. XIV no. 4 (October-December 2011): 77-79."
  },{
    details:"Gorman Michael J. Becoming the Gospel: Paul, Participation, and Mission. Grand Rapids, Michigan: William B. Eerdmans Publishing Company, 2015, pages 341. Third Millennium vol. XVIII no. 2 (April-June 2015): 107-112."
  },{
    details:"Hubbard Jr., Robert L., and Andrew Dearman. Introducing the Old Testament. Grand Rapids, Michigan: William B. Eerdmans Publishing Company, 2018, pages XXII + 538. Third Millennium (October-December 2019)."
  },{
    details:"William D.H. (translator and editor). Matthew: Interpreted by early Christian Commentators. In The Church’s Bible. General editor Robert Louis Wilken. Grand Rapids, Michigan: William B. Eerdmans Publishing Company, 2018, pages XXVIII + 570. Third Millennium vol. XXIII no. 2 (April-June 2020): 96-98."
  },{
    details:"Verhoef Peter A. The Books of Haggai and Malachi. Grand Rapids, Michigan: William B. Eerdmans Publishing Company, 2018, pages XXV + 364. Third Millennium vol. XXIV no. 2 (April-June 2021): 111-112."
  }],
  generalArticles:[{
    details:"Bible Diary 2016, 2017, 2018, 2019. (Reflections on the Daily Readings.)"
  },{
    details:"“Reflections on the Daily Readings for Four Weeks.” In Bible Diary 2020-2025."
  },{
    details:"“Yob.” (Explanation of Job.) (June 2021)."
  },{
    details:"“Gurjardhara par Spanish Isusanghioni Sadi: Ramon Grauthi Jokim Castiella Sudhi.” (Centenary of the Spanish Jesuits in the Land of Gujarat: From Ramon Grau to Jokim Castiella.) Doot (October 2021)."
  },{
    details:"“Loyolana Sant Ignasne Name Ullekhit Avtarano.” (The Quotes of Ignatius of Loyola.) Doot (October 2021)."
  },{
    details:"“Hun pan tane saja nathi karato.” (I, too, do not condemn you.) Doot (March 2022): 22-24."
  },{
    details:"“Preshitik Ravivar: Preshitik Tappa Dod.” (The Mission Sunday: Mission Relay Race.) Doot (October 2022): 14-16."
  },{
    details:"“Hun Kon chhun?  Tun Shun kahe chhe?” (Who am I?  What do you say?) Doot (December 2022): 5-7."
  },{
    details:"Eight Articles on Christology. Pages 1-167 (except 61-108) in Jivanudharak Prabhu Isu. (Jesus, the Lord and Saviour.) January 2023."
  },{
    details:"“Bal Isunan Mother Marie Jema: 14th November 1933- 20th January 2023.” (Mother Marie Gemma of the Child Jesus: 14th November 1933-20th January 2023.) (Obituary.) Doot (April 2023): 2-4."
  },{
    details:"“Adachan ane Nirakaran.” (Problem and Solution.) Doot (July 2023): 10-12."
  },{
    details:"“Punrutthanman praveshvano Password: Isuman Shraddha.” (The password to enter into the resurrection: Faith in Jesus.) Doot (March 2024): 5-7."
  },{
    details:"“Sant Ignasni Adhyatmasadhana.” (The Spirituality of Saint Ignatius.) Doot (May 2024): 21-23."
  },{
    details:"“Bhale Prabhuji, thajo Dharyun Tamarun.” (Well Lord, Thy Will be done.) Doot (July 2024): 31-33."
  },{
    details:"“Amdavad Dhramaprantaman Shraddha Ghadatar.” (Faith Formation in the Diocese of Ahmedabad.) Doot (October 2024): 58-61."
  },{
    details:"“Aa Andhakarne Kon hatavashe?” (Who will remove this darkness?) Doot (December 2024): 16-18."
  },{
    details:"“Amdavad Dharmaprantman Shraddha Ghadtar.” (Faith Formation in Ahmedabad Diocese.) In Smrutigranth December 2024."
  },{
    details:"“Mari pasandaginu Tap ke Isue ichhelo Taap?” (Suffering that I chose or Jesus willed?) Doot (February 2025): 59-61."
  },{
    details:"“Rabbuni Arthat Guruji.” (Master.) Doot (April 2025): 61-63."
  },{
    details:"“Isusangh ane Ashanan Yatrio.” (The Society of Jesus and Pilgrims of Hope.) Doot (July 2025): 45-47."
  },{
    details:"“Magis.” Doot (September 2025). (Forthcoming Article)"
  },{
    details:"“Snehnan Spandan.” (Reflections on the Daily Gospel Reading.) 2021-2025."
  },{
    details:"Manuscripts of Bible Darshan submitted to the Press on 22nd March 2025. (Forthcoming Book)"
  }],
    academicQualification:[{
      degree:"B.Sc. Dairy Science",
      year:"1974-78",
      college:"Sheth M.C. College of Dairy Science, Anand"
    },{
      degree:"Bachelor of Philosophy",
      year:"1982-84",
      college:"Jnana Deepa Institute of Philosophy and Theology, Pune"
    },{
      degree:"Bachelor of Theology",
      year:"1985-88",
      college:"RTC and Vidyajyoti"
    },{
      degree:"Licentiate in Sacred Scriptures (SSL)",
      year:"1990-94",
      college:"Biblicum, Rome"
    },{
      degree:"Doctorate in Sacred Theology (STD)",
      year:"2005-09",
      college:"Santa Clara University, Berkley, USA"
    }
  ],
    currentTeaching:"Reader,Teacher – Scriptures, Director of Post Graduate Studies, Student Mentor, Spiritual Director, Asst. Director, DEPTh",
    previousTeaching:[{
      details:"Technical Officer – Amul Dairy, Anand",
      year:"1978-79"
    },{
      details:"Teacher and Asst. Director – Regional Theology Center, Ahmedabad",
      year:"1995-97"
    },{
      details:"Teacher and Rector – Gujarat Vidya-Deep Regional Seminary, Ahmedabad",
      year:"1998-2005"
    },{
      details:"Teacher - Gujarat Vidya-Deep Regional Seminary, Ahmedabad",
      year:"2010-13"
    },{
      details:"Teacher and Dean – Gujarat Vidya-Deep Regional Seminary, Ahmedabad",
      year:"2013-20"
    }],
    category:"Scripture",
    avatarSrc:require('./assets/photos/FrJamesBDabhi.jpg')
  },{
    id:8,
    title:"Lecturer",
    subTitle:"",
    name:"Fr. James Kulvi SJ",
    category:"Scripture",
    emailID:"jameskulvi@gmail.com",
    province:"Kohima",
    currentTeaching:"Lecturer, Sacred Scripture",
    academicQualification:[{
      degree:"Bachelor of Science in Visual Communication",
      year:"2008-2011",
      college:"Loyola College, affiliated to Madras University, Chennai"
    },{
      degree:"Bachelor of Arts in Philosophy from Jnana-Deepa",
      year:"2011-2013",
      college:"Pontifical Institute of Philosophy and Religion, Pune"
    },{
      degree:"Master of Arts in Philosophy",
      year:"2011-2013",
      college:"Indira Gandhi National Open University, Pune"
    },{
      degree:"Bachelor in Sacred Theology (BST)",
      year:"2015-2018",
      college:"Pontifical Gregorian University, Rome"
    },{
      degree:"Licentiate in Sacred Scripture (SSL)",
      year:"2018-2022",
      college:"Pontifical Biblical Institute, Rome"
    }],
    bookReviews:[{
    details:"The Holy Spirit, Our Divine Mother. Authored by George Mlakuzhyil SJ. Anand, Gujarat: Gujarat Sahitya Prakash, 2023."
  }],
  booksPublished:[{
      details:"Jesuits & Children (Published by INI: A new online magazine – an initiative of the Madurai Jesuit Province, 14/11/2023)."
    },{
      details:"A Reflection on the Document on Human Fraternity – For World Peace and Living Together (Published by Salaam – Quarterly to Promote Understanding, Islamic Studies Association Vol. 44, October 2023, No. 4)."
    },{
      details:"Academic Paper: “Generation Zero — Youth Beneficiaries or Victims of Change” from the Perspective of Catholic Theology and Teachings (2024 – Published by Oriens Theological College, Shillong, Meghalaya).",
    }],
    avatarSrc:require('./assets/photos/James.jpeg')
  },{
    id:9,
    title:"Lecturer",
    subTitle:"",
    name:"Fr. Jesu Thason OCD",
    category:"Scripture",
    avatarSrc:require('./assets/photos/jesu.jpg')
  },{
    id:10,
    title:"Counselor",
    subTitle:"",
    name:"Fr. George Beck",
    category:"Counselor",
    emailID:"gmbecksj@gmail.com",
    province:"Dumka Raiganj",
    currentTeaching:"Spiritual Director",
    previousTeaching:[{
      details:"Rector"
    },{
      details:"Superior"
    },{
      details:"Formator"
    },{
      details:"Spiritual Director"
    }],
    academicQualification:[{
      degree:"M.A",
      year:"",
      college:""
    },{
      degree:"B.Ed",
      year:"",
      college:""
    }],
    avatarSrc:require('./assets/photos/FrGeorgeBeck.jpg')
  },{
    id:11,
    title:"Counsellor",
    subTitle:"",
    name:"Fr. Boniface D’Souza",
    category:"Counselor",
    emailID:"bonids@gmail.com",
    province:"Kohima",
    currentTeaching:"Counsellor",
    previousTeaching:[{
      details:"Counsellor"
    },{
      details:"Teacher, Psychology"
    }],
    academicQualification:[{
      degree:"Licentiate",
      year:"",
      college:""
    },{
      degree:"Doctor of Psychology",
      year:"",
      college:""
    }],
    avatarSrc:require('./assets/photos/boni.jpg')
  },{
    id:13,
    title:"Lecturer",
    subTitle:"",
    name:"Fr. Roshan Kiro, SJ",
    category:"Systematic Theology",
    emailID:"roshan.kiro@jesuits.net",
    province:"Darjeeling",
    currentTeaching:"Lecturer - Systematic Theology",
    previousTeaching:[{
      details:"Teacher - Early Jesuit formation"
    }],
    academicQualification:[{
      degree:"Bachelor of science (Zoology)",
      year:"2008-11",
      college:"St. Xavier’s College, Ahmedabad"
    },{
      degree:"Bachelor of Philosophy",
      year:"2011-13",
      college:"Pontifical Institute of Philosophy and Religion, Pune"
    },{
      degree:"Bachelor of Sacred Theology (STB)",
      year:"2014-17",
      college:"Regis College at the University of Toronto, Canada"
    },{
      degree:"Master of Divinity",
      year:"2014-17",
      college:"Regis College at the University of Toronto, Canada"
    },{
      degree:"Licentiate in Sacred Theology (STL)",
      year:"2017-19",
      college:"Regis College at the University of Toronto, Canada"
    },{
      degree:"Master of Theology",
      year:"2017-19",
      college:"Regis College at the University of Toronto, Canada"
    },{
      degree:"MSc. in Counselling Psychology",
      year:"2022-24",
      college:"Martin Luther Christian University, Meghalaya"
    }],
    researchArticles:[{
    details:"“Forced Migration and its impact on the Mental Health of the Young Adults of Manipur- A Mixed Methods Study”"
  }],
    avatarSrc:require('./assets/photos/FrRoshanKiro.jpg')
  }];

  export const cstList=[{
    id:1,
    date:"08 - 09 July",
    subjects:"Inauguration and Orientation",
    by:"",
    year:"1"
  },{
    id:2,
    date:"10 - 26 July",
    subjects:"Research Methodology & Hermeneutics of Contextual Theological Methods",
    by:"Dr. Fr. Vincent Kundukulam",
    year:"1"
  },{
    id:3,
    date:"29 - 16 August",
    subjects:"Modern Trends in Theological Anthropology",
    by:"Dr. Anil  D’ Almeida SJ",
    year:"1"
  },{
    id:4,
    date:"Aug 19 – 06 Sep",
    subjects:"Exploring Trends in Trinitarian Theology",
    by:"Dr.  Jossie Lobo SJ",
    year:"1"
  },{
    id:5,
    date:"Sep 09 – 27 Sep",
    subjects:"Contemporary Issues in Christology",
    by:"Dr. Thomas Kuriakose SJ",
    year:"1"
  },{
    id:6,
    date:"Sep 30 – 25 Oct & Oct 12  – 10 ",
    subjects:"Biblical Hermeneutics",
    by:"Dr. Valan C. Antony SJ",
    year:"1"
  },{
    id:7,
    date:"Oct 28 –22 Nov & Nov 1-9 ",
    subjects:"Theology of Councils: Emphasis on Vat-II",
    by:"Dr. Jesu Raj SVD",
    year:"1"
  },{
    id:8,
    date:"Nov25-20 Dec & (Seminar:28-29Nov)",
    subjects:"Sacraments: Paradigm Shifts & Indian Samskaras",
    by:"Dr. Rajakumar Joseph SJ",
    year:"1"
  },{
    id:9,
    date:"Jan 06 - 24",
    subjects:"Contemporary Trends in Ecclesiology",
    by:"Dr. Sr. Evelyn Monteiro",
    year:"1"
  },{
    id:10,
    date:"Jan 27 – 14 Feb",
    subjects:"Theology of Religions",
    by:"Dr. Victor Edwin Joseph SJ",
    year:"1"
  },{
    id:11,
    date:"Feb 17 – April 07",
    subjects:"Guided Paper (1)",
    year:"1"
  },{
    id:12,
    date:"Feb 24 – 07 Mar",
    subjects:"Greek",
    by:"Dr. Jimmy Dhabi SJ",
    year:"1"
  },{
    id:13,
    date:"Mar 10 – 28 Mar",
    subjects:"Latin",
    by:"Dr. Jimmy Dhabi SJ and Dr. Augustine SJ",
    year:"1"
  },{
    id:14,
    date:"April 8 – 30 April, Submit-July 11, ‘25",
    subjects:"Guided Paper (2)",
    year:"1"
  },{
    id:15,
    date:"July 14 – 1 Aug, 2025",
    subjects:"Indian Christology: Method & Issues",
    by:"Dr. Jacob Parapally MSFS",
    year:"2"
  },{
    id:16,
    date:"Aug 04 - 22",
    subjects:"Peace and Reconciliation in the Bible",
    by:"Dr. Edwin Rodrigues SJ",
    year:"2"
  },{
    id:17,
    date:"Sep 25 – 17 Oct",
    subjects:"Political Theology: Public & Subaltern & Liberation Theology",
    by:"Dr. Gnana Patrick",
    year:"2"
  },{
    id:18,
    date:"Oct 20 – 07 Nov",
    subjects:"Issues in Bio - Ethics & Guarding the Vulnerable Adults",
    by:"Dr. Stanislaus  Alla SJ",
    year:"2"
  },{
    id:19,
    date:"Nov 10 – 28 Nov",
    subjects:"Integral Ecology / Mariology",
    by:"Dr. Jose Mathew SJ",
    year:"2"
  },{
    id:20,
    date:"Dec 01 – 19 Dec",
    subjects:"Inculturation, Evangelization & Inter-Rel. Dial ",
    by:"Dr. Rajakumar & VJ-TEAM Teaching",
    year:"2"
  },{
    id:21,
    date:"Dec 10 – 25 Mar ",
    subjects:"Dissertation Paper (3)",
    year:"2"
  },{
    id:1,
    date:"08 - 09 July",
    subjects:"Inauguration and Orientation",
    year:"1"
  }]

  export const newlist=[
    {
      id:1,
      title:"ave",
      imgSrc:require('./assets/photos/ave.jpg')
    },
    {
      id:2,
      title:"vjtr",
      imgSrc:require('./assets/photos/vjtr.jpg')
    }
  ]

  export const phoneCode=[
    {
      "Country": "USA",
      "Code": "+1"
    },
    {
      "Country": "RUS",
      "Code": "+7"
    },
    {
      "Country": "EGY",
      "Code": "+20"
    },
    {
      "Country": "ZAF",
      "Code": "+27"
    },
    {
      "Country": "GRC",
      "Code": "+30"
    },
    {
      "Country": "NLD",
      "Code": "+31"
    },
    {
      "Country": "BEL",
      "Code": "+32"
    },
    {
      "Country": "FRA",
      "Code": "+33"
    },
    {
      "Country": "ESP",
      "Code": "+34"
    },
    {
      "Country": "HUN",
      "Code": "+36"
    },
    {
      "Country": "ITA",
      "Code": "+39"
    },
    {
      "Country": "ROU",
      "Code": "+40"
    },
    {
      "Country": "CHE",
      "Code": "+41"
    },
    {
      "Country": "AUT",
      "Code": "+43"
    },
    {
      "Country": "GBR",
      "Code": "+44"
    },
    {
      "Country": "DNK",
      "Code": "+45"
    },
    {
      "Country": "SWE",
      "Code": "+46"
    },
    {
      "Country": "NOR",
      "Code": "+47"
    },
    {
      "Country": "POL",
      "Code": "+48"
    },
    {
      "Country": "DEU",
      "Code": "+49"
    },
    {
      "Country": "PER",
      "Code": "+51"
    },
    {
      "Country": "MEX",
      "Code": "+52"
    },
    {
      "Country": "CUB",
      "Code": "+53"
    },
    {
      "Country": "ARG",
      "Code": "+54"
    },
    {
      "Country": "BRA",
      "Code": "+55"
    },
    {
      "Country": "CHL",
      "Code": "+56"
    },
    {
      "Country": "COL",
      "Code": "+57"
    },
    {
      "Country": "VEN",
      "Code": "+58"
    },
    {
      "Country": "MYS",
      "Code": "+60"
    },
    {
      "Country": "AUS",
      "Code": "+61"
    },
    {
      "Country": "IDN",
      "Code": "+62"
    },
    {
      "Country": "PHL",
      "Code": "+63"
    },
    {
      "Country": "NZL",
      "Code": "+64"
    },
    {
      "Country": "SGP",
      "Code": "+65"
    },
    {
      "Country": "THA",
      "Code": "+66"
    },
    {
      "Country": "JPN",
      "Code": "+81"
    },
    {
      "Country": "KOR",
      "Code": "+82"
    },
    {
      "Country": "VNM",
      "Code": "+84"
    },
    {
      "Country": "CHN",
      "Code": "+86"
    },
    {
      "Country": "TUR",
      "Code": "+90"
    },
    {
      "Country": "IND",
      "Code": "+91"
    },
    {
      "Country": "PAK",
      "Code": "+92"
    },
    {
      "Country": "AFG",
      "Code": "+93"
    },
    {
      "Country": "LKA",
      "Code": "+94"
    },
    {
      "Country": "MMR",
      "Code": "+95"
    },
    {
      "Country": "IRN",
      "Code": "+98"
    },
    {
      "Country": "SSD",
      "Code": "+211"
    },
    {
      "Country": "ESH",
      "Code": "+212"
    },
    {
      "Country": "DZA",
      "Code": "+213"
    },
    {
      "Country": "TUN",
      "Code": "+216"
    },
    {
      "Country": "LBY",
      "Code": "+218"
    },
    {
      "Country": "GMB",
      "Code": "+220"
    },
    {
      "Country": "SEN",
      "Code": "+221"
    },
    {
      "Country": "MRT",
      "Code": "+222"
    },
    {
      "Country": "MLI",
      "Code": "+223"
    },
    {
      "Country": "GIN",
      "Code": "+224"
    },
    {
      "Country": "CIV",
      "Code": "+225"
    },
    {
      "Country": "BFA",
      "Code": "+226"
    },
    {
      "Country": "NER",
      "Code": "+227"
    },
    {
      "Country": "TGO",
      "Code": "+228"
    },
    {
      "Country": "BEN",
      "Code": "+229"
    },
    {
      "Country": "MUS",
      "Code": "+230"
    },
    {
      "Country": "LBR",
      "Code": "+231"
    },
    {
      "Country": "SLE",
      "Code": "+232"
    },
    {
      "Country": "GHA",
      "Code": "+233"
    },
    {
      "Country": "NGA",
      "Code": "+234"
    },
    {
      "Country": "TCD",
      "Code": "+235"
    },
    {
      "Country": "CAF",
      "Code": "+236"
    },
    {
      "Country": "CMR",
      "Code": "+237"
    },
    {
      "Country": "CPV",
      "Code": "+238"
    },
    {
      "Country": "STP",
      "Code": "+239"
    },
    {
      "Country": "GNQ",
      "Code": "+240"
    },
    {
      "Country": "GAB",
      "Code": "+241"
    },
    {
      "Country": "COG",
      "Code": "+242"
    },
    {
      "Country": "COD",
      "Code": "+243"
    },
    {
      "Country": "AGO",
      "Code": "+244"
    },
    {
      "Country": "GNB",
      "Code": "+245"
    },
    {
      "Country": "IOT",
      "Code": "+246"
    },
    {
      "Country": "SYC",
      "Code": "+248"
    },
    {
      "Country": "SDN",
      "Code": "+249"
    },
    {
      "Country": "RWA",
      "Code": "+250"
    },
    {
      "Country": "ETH",
      "Code": "+251"
    },
    {
      "Country": "SOM",
      "Code": "+252"
    },
    {
      "Country": "DJI",
      "Code": "+253"
    },
    {
      "Country": "KEN",
      "Code": "+254"
    },
    {
      "Country": "TZA",
      "Code": "+255"
    },
    {
      "Country": "UGA",
      "Code": "+256"
    },
    {
      "Country": "BDI",
      "Code": "+257"
    },
    {
      "Country": "MOZ",
      "Code": "+258"
    },
    {
      "Country": "ZMB",
      "Code": "+260"
    },
    {
      "Country": "MDG",
      "Code": "+261"
    },
    {
      "Country": "REU",
      "Code": "+262"
    },
    {
      "Country": "ZWE",
      "Code": "+263"
    },
    {
      "Country": "NAM",
      "Code": "+264"
    },
    {
      "Country": "MWI",
      "Code": "+265"
    },
    {
      "Country": "LSO",
      "Code": "+266"
    },
    {
      "Country": "BWA",
      "Code": "+267"
    },
    {
      "Country": "SWZ",
      "Code": "+268"
    },
    {
      "Country": "COM",
      "Code": "+269"
    },
    {
      "Country": "SHN",
      "Code": "+290"
    },
    {
      "Country": "ERI",
      "Code": "+291"
    },
    {
      "Country": "ABW",
      "Code": "+297"
    },
    {
      "Country": "FRO",
      "Code": "+298"
    },
    {
      "Country": "GRL",
      "Code": "+299"
    },
    {
      "Country": "GIB",
      "Code": "+350"
    },
    {
      "Country": "PRT",
      "Code": "+351"
    },
    {
      "Country": "LUX",
      "Code": "+352"
    },
    {
      "Country": "IRL",
      "Code": "+353"
    },
    {
      "Country": "ISL",
      "Code": "+354"
    },
    {
      "Country": "ALB",
      "Code": "+355"
    },
    {
      "Country": "MLT",
      "Code": "+356"
    },
    {
      "Country": "CYP",
      "Code": "+357"
    },
    {
      "Country": "FIN",
      "Code": "+358"
    },
    {
      "Country": "BGR",
      "Code": "+359"
    },
    {
      "Country": "LTU",
      "Code": "+370"
    },
    {
      "Country": "LVA",
      "Code": "+371"
    },
    {
      "Country": "EST",
      "Code": "+372"
    },
    {
      "Country": "MDA",
      "Code": "+373"
    },
    {
      "Country": "ARM",
      "Code": "+374"
    },
    {
      "Country": "BLR",
      "Code": "+375"
    },
    {
      "Country": "AND",
      "Code": "+376"
    },
    {
      "Country": "MCO",
      "Code": "+377"
    },
    {
      "Country": "SMR",
      "Code": "+378"
    },
    {
      "Country": "UKR",
      "Code": "+380"
    },
    {
      "Country": "SRB",
      "Code": "+381"
    },
    {
      "Country": "MNE",
      "Code": "+382"
    },
    {
      "Country": "XKX",
      "Code": "+383"
    },
    {
      "Country": "HRV",
      "Code": "+385"
    },
    {
      "Country": "SVN",
      "Code": "+386"
    },
    {
      "Country": "BIH",
      "Code": "+387"
    },
    {
      "Country": "MKD",
      "Code": "+389"
    },
    {
      "Country": "CZE",
      "Code": "+420"
    },
    {
      "Country": "SVK",
      "Code": "+421"
    },
    {
      "Country": "LIE",
      "Code": "+423"
    },
    {
      "Country": "FLK",
      "Code": "+500"
    },
    {
      "Country": "BLZ",
      "Code": "+501"
    },
    {
      "Country": "GTM",
      "Code": "+502"
    },
    {
      "Country": "SLV",
      "Code": "+503"
    },
    {
      "Country": "HND",
      "Code": "+504"
    },
    {
      "Country": "NIC",
      "Code": "+505"
    },
    {
      "Country": "CRI",
      "Code": "+506"
    },
    {
      "Country": "PAN",
      "Code": "+507"
    },
    {
      "Country": "SPM",
      "Code": "+508"
    },
    {
      "Country": "HTI",
      "Code": "+509"
    },
    {
      "Country": "BLM",
      "Code": "+590"
    },
    {
      "Country": "BOL",
      "Code": "+591"
    },
    {
      "Country": "GUY",
      "Code": "+592"
    },
    {
      "Country": "ECU",
      "Code": "+593"
    },
    {
      "Country": "PRY",
      "Code": "+595"
    },
    {
      "Country": "SUR",
      "Code": "+597"
    },
    {
      "Country": "URY",
      "Code": "+598"
    },
    {
      "Country": "ANT",
      "Code": "+599"
    },
    {
      "Country": "TLS",
      "Code": "+670"
    },
    {
      "Country": "ATA",
      "Code": "+672"
    },
    {
      "Country": "BRN",
      "Code": "+673"
    },
    {
      "Country": "NRU",
      "Code": "+674"
    },
    {
      "Country": "PNG",
      "Code": "+675"
    },
    {
      "Country": "TON",
      "Code": "+676"
    },
    {
      "Country": "SLB",
      "Code": "+677"
    },
    {
      "Country": "VUT",
      "Code": "+678"
    },
    {
      "Country": "FJI",
      "Code": "+679"
    },
    {
      "Country": "PLW",
      "Code": "+680"
    },
    {
      "Country": "WLF",
      "Code": "+681"
    },
    {
      "Country": "COK",
      "Code": "+682"
    },
    {
      "Country": "NIU",
      "Code": "+683"
    },
    {
      "Country": "WSM",
      "Code": "+685"
    },
    {
      "Country": "KIR",
      "Code": "+686"
    },
    {
      "Country": "NCL",
      "Code": "+687"
    },
    {
      "Country": "TUV",
      "Code": "+688"
    },
    {
      "Country": "PYF",
      "Code": "+689"
    },
    {
      "Country": "TKL",
      "Code": "+690"
    },
    {
      "Country": "FSM",
      "Code": "+691"
    },
    {
      "Country": "MHL",
      "Code": "+692"
    },
    {
      "Country": "PRK",
      "Code": "+850"
    },
    {
      "Country": "HKG",
      "Code": "+852"
    },
    {
      "Country": "MAC",
      "Code": "+853"
    },
    {
      "Country": "KHM",
      "Code": "+855"
    },
    {
      "Country": "LAO",
      "Code": "+856"
    },
    {
      "Country": "BGD",
      "Code": "+880"
    },
    {
      "Country": "TWN",
      "Code": "+886"
    },
    {
      "Country": "MDV",
      "Code": "+960"
    },
    {
      "Country": "LBN",
      "Code": "+961"
    },
    {
      "Country": "JOR",
      "Code": "+962"
    },
    {
      "Country": "SYR",
      "Code": "+963"
    },
    {
      "Country": "IRQ",
      "Code": "+964"
    },
    {
      "Country": "KWT",
      "Code": "+965"
    },
    {
      "Country": "SAU",
      "Code": "+966"
    },
    {
      "Country": "YEM",
      "Code": "+967"
    },
    {
      "Country": "OMN",
      "Code": "+968"
    },
    {
      "Country": "PSE",
      "Code": "+970"
    },
    {
      "Country": "ARE",
      "Code": "+971"
    },
    {
      "Country": "ISR",
      "Code": "+972"
    },
    {
      "Country": "BHR",
      "Code": "+973"
    },
    {
      "Country": "QAT",
      "Code": "+974"
    },
    {
      "Country": "BTN",
      "Code": "+975"
    },
    {
      "Country": "MNG",
      "Code": "+976"
    },
    {
      "Country": "NPL",
      "Code": "+977"
    },
    {
      "Country": "TJK",
      "Code": "+992"
    },
    {
      "Country": "TKM",
      "Code": "+993"
    },
    {
      "Country": "AZE",
      "Code": "+994"
    },
    {
      "Country": "GEO",
      "Code": "+995"
    },
    {
      "Country": "KGZ",
      "Code": "+996"
    },
    {
      "Country": "UZB",
      "Code": "+998"
    }
  ];

  export const optionalCoursesList=[{
    id:1,
    course:"Biblical Greek",
    credits:1
  },{
    id:2,
    course:"Book of Revelation",
    credits:1
  },{
    id:3,
    course:"Canon Law for Religious",
    credits:1
  },{
    id:4,
    course:"Letter to the Hebrews",
    credits:1
  },{
    id:5,
    course:"Judaism",
    credits:1
  },{
    id:6,
    course:"Sufism",
    credits:1
  },{
    id:7,
    course:"Themes in Feminist Theology",
    credits:1
  },{
    id:8,
    course:"Ethics of Child Protection",
    credits:1
  },{
    id:9,
    course:"Pastoral Liturgy",
    credits:1
  },{
    id:10,
    course:"Canon Law on Sacraments",
    credits:1
  },{
    id:11,
    course:"Indians Constitution",
    credits:1
  },{
    id:12,
    course:"Integral Ecology",
    credits:1
  },{
    id:13,
    course:"Peace and Reconciliation",
    credits:1
  },{
    id:14,
    course:"Ignatian Spirituality",
    credits:1
  }];

  export const vjcTopStoriesList=[{
    clientID:"VJCollege",
timelineID:"1",
timelineDisplay:"Yes",
timelineTitle:"INTERNATIONAL WOMEN’S DAY CELEBRATION",
timelineHeader:"08 MARCH, 2024",
timelineDescription:"On the occasion of International Women’s Day, 8th March 2024, an extension lecture was organized to commemorate the significance of the day and to shed light on the challenges and achievements of women globally. The event was graced by esteemed speaker and participants, contributing to a meaningful discussion on the empowerment of women and gender equality. Dr. Ella Sonawane, the Associate General Secretary of ISPCK, Delhi, served as the spokesperson for International Women’s Day. Dr. Ella, a strong advocate for women’s rights and empowerment, shared her insights and experiences on the occasion. The principal, Fr. Rajkumar introduced Dr. Ella, highlighting her remarkable achievements as a strong woman, author, speaker, and social service advocate. On this special occasion all the sisters present were felicitated with a bouquet, symbolizing appreciation and recognition for their roles and contributions. Dr. Ella shared her insights into the roles and challenges faced by women in society, drawing attention to patriarchal norms, bias, and the lack of political and economic representation. And also Dr. Ella cited examples from Uttar Pradesh and Punjab where empowered women have made significant progress, enabling them to voice their concerns and participate actively in society. The theme of inclusion resonated throughout the discussion, with emphasis placed on encouraging a culture where women are respected and empowered. Dr. Ella stressed the importance of men embracing feminism and supporting gender equality initiatives, emphasizing that the empowerment of women is crucial for societal development. So, the International Women’s Day extension lecture provided a platform for meaningful dialogue and reflection on the status of women in society. Through the insightful discussions and reflections, participants were inspired to champion the cause of gender equality and work towards creating a more inclusive and equitable world for all.",
timelineImage:"",
updatedBy:"TEST",
updatedOn:"TEST",
timelineColor:"#4CADAD"
  },{
    clientID:"VJCollege",
timelineID:"1",
timelineDisplay:"Yes",
timelineTitle:"INTERNATIONAL WOMEN’S DAY CELEBRATION",
timelineHeader:"08 MARCH, 2024",
timelineDescription:"On the occasion of International Women’s Day, 8th March 2024, an extension lecture was organized to commemorate the significance of the day and to shed light on the challenges and achievements of women globally. The event was graced by esteemed speaker and participants, contributing to a meaningful discussion on the empowerment of women and gender equality. Dr. Ella Sonawane, the Associate General Secretary of ISPCK, Delhi, served as the spokesperson for International Women’s Day. Dr. Ella, a strong advocate for women’s rights and empowerment, shared her insights and experiences on the occasion. The principal, Fr. Rajkumar introduced Dr. Ella, highlighting her remarkable achievements as a strong woman, author, speaker, and social service advocate. On this special occasion all the sisters present were felicitated with a bouquet, symbolizing appreciation and recognition for their roles and contributions. Dr. Ella shared her insights into the roles and challenges faced by women in society, drawing attention to patriarchal norms, bias, and the lack of political and economic representation. And also Dr. Ella cited examples from Uttar Pradesh and Punjab where empowered women have made significant progress, enabling them to voice their concerns and participate actively in society. The theme of inclusion resonated throughout the discussion, with emphasis placed on encouraging a culture where women are respected and empowered. Dr. Ella stressed the importance of men embracing feminism and supporting gender equality initiatives, emphasizing that the empowerment of women is crucial for societal development. So, the International Women’s Day extension lecture provided a platform for meaningful dialogue and reflection on the status of women in society. Through the insightful discussions and reflections, participants were inspired to champion the cause of gender equality and work towards creating a more inclusive and equitable world for all.",
timelineImage:"",
updatedBy:"TEST",
updatedOn:"TEST",
timelineColor:"#4CADAD"
  },{
    clientID:"VJCollege",
timelineID:"1",
timelineDisplay:"Yes",
timelineTitle:"INTERNATIONAL WOMEN’S DAY CELEBRATION",
timelineHeader:"08 MARCH, 2024",
timelineDescription:"On the occasion of International Women’s Day, 8th March 2024, an extension lecture was organized to commemorate the significance of the day and to shed light on the challenges and achievements of women globally. The event was graced by esteemed speaker and participants, contributing to a meaningful discussion on the empowerment of women and gender equality. Dr. Ella Sonawane, the Associate General Secretary of ISPCK, Delhi, served as the spokesperson for International Women’s Day. Dr. Ella, a strong advocate for women’s rights and empowerment, shared her insights and experiences on the occasion. The principal, Fr. Rajkumar introduced Dr. Ella, highlighting her remarkable achievements as a strong woman, author, speaker, and social service advocate. On this special occasion all the sisters present were felicitated with a bouquet, symbolizing appreciation and recognition for their roles and contributions. Dr. Ella shared her insights into the roles and challenges faced by women in society, drawing attention to patriarchal norms, bias, and the lack of political and economic representation. And also Dr. Ella cited examples from Uttar Pradesh and Punjab where empowered women have made significant progress, enabling them to voice their concerns and participate actively in society. The theme of inclusion resonated throughout the discussion, with emphasis placed on encouraging a culture where women are respected and empowered. Dr. Ella stressed the importance of men embracing feminism and supporting gender equality initiatives, emphasizing that the empowerment of women is crucial for societal development. So, the International Women’s Day extension lecture provided a platform for meaningful dialogue and reflection on the status of women in society. Through the insightful discussions and reflections, participants were inspired to champion the cause of gender equality and work towards creating a more inclusive and equitable world for all.",
timelineImage:"",
updatedBy:"TEST",
updatedOn:"TEST",
timelineColor:"#4CADAD"
  },{
    clientID:"VJCollege",
timelineID:"1",
timelineDisplay:"Yes",
timelineTitle:"INTERNATIONAL WOMEN’S DAY CELEBRATION",
timelineHeader:"08 MARCH, 2024",
timelineDescription:"On the occasion of International Women’s Day, 8th March 2024, an extension lecture was organized to commemorate the significance of the day and to shed light on the challenges and achievements of women globally. The event was graced by esteemed speaker and participants, contributing to a meaningful discussion on the empowerment of women and gender equality. Dr. Ella Sonawane, the Associate General Secretary of ISPCK, Delhi, served as the spokesperson for International Women’s Day. Dr. Ella, a strong advocate for women’s rights and empowerment, shared her insights and experiences on the occasion. The principal, Fr. Rajkumar introduced Dr. Ella, highlighting her remarkable achievements as a strong woman, author, speaker, and social service advocate. On this special occasion all the sisters present were felicitated with a bouquet, symbolizing appreciation and recognition for their roles and contributions. Dr. Ella shared her insights into the roles and challenges faced by women in society, drawing attention to patriarchal norms, bias, and the lack of political and economic representation. And also Dr. Ella cited examples from Uttar Pradesh and Punjab where empowered women have made significant progress, enabling them to voice their concerns and participate actively in society. The theme of inclusion resonated throughout the discussion, with emphasis placed on encouraging a culture where women are respected and empowered. Dr. Ella stressed the importance of men embracing feminism and supporting gender equality initiatives, emphasizing that the empowerment of women is crucial for societal development. So, the International Women’s Day extension lecture provided a platform for meaningful dialogue and reflection on the status of women in society. Through the insightful discussions and reflections, participants were inspired to champion the cause of gender equality and work towards creating a more inclusive and equitable world for all.",
timelineImage:"",
updatedBy:"TEST",
updatedOn:"TEST",
timelineColor:"#4CADAD"
  }]